<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.scss";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import Swal from "sweetalert2";
import Lottie from "@/components/widgets/lottie.vue";
import axios from "axios";
import animationData from "@/components/widgets/msoeawqm.json";
// import calendar from "../../components/appoinmentCalendar";
import jwt_decode from "jwt-decode";

// components
import notes from '../../components/users/notes';
import Papa from "papaparse";
import * as XLSX from "xlsx";

import loader from "../../components/widgets/loader";

export default {
  page: {
    title: "Agents",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    PageHeader,
    lottie: Lottie,
    Multiselect,
    flatPickr,
    notes,
    // calendar,
    loader
  },
  data() {
    return{
      title: "Agent List",
      items: [
        {
          text: "Agents",
          href: "/",
        },
        {
          text: "Agent List",
          active: true,
        },
      ],
      timeConfig: {
        enableTime: false,
        dateFormat: "d M, Y"
      },
      dateTimeConfig: {
        enableTime: true,
        dateFormat: "F j, Y H:i K"
      },
      list: [],
      listQty: 0,
      isEditMode: false,
      calendarCopied: false,
      copiedGlobalLabel: null,
      agentData: {
        username: '',
        email: '',
        firstName: '',
        lastName: '',
        language: '',
        status: '',
        phone: '',
        department: '',
        state: '',
        birthDate: '',
        address: '',
        country: 'USA',
        zipCode: '',
        interview: '',
        agentNumber: '',
        createdBy: '',
        insuranceLicense: '',
        licenseNumber: '',
        note: '',
        profileIMG: ''
      },
      departmentList: {},
      statusList: {},
      sourcesList: {},
      statesList: {},
      typeList: {},
      page: 1,
      perPage: 100,
      pages: [],
      searchQuery: null,
      humanfriendlyConfig: {
        dateFormat: "F j, Y",
      },
      data: {
        token: localStorage.getItem('jwt'),
        searchValues: {
          limitTo: this.perPage,
          source: [],
          isActive: 1,
          noteSearch: '',
          keyword: '',
          licensed: 1,
          language: 3,
          status: [],
          sortBy: 'name',
          orderBy: 'ASC',
          dateRange: 0,
          statesList: [],
          department: [],
          toDate: new Date().toLocaleDateString('en-us', { year:"numeric", month:"long", day:"numeric"}) ,
          fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toLocaleDateString('en-us', { year:"numeric", month:"long", day:"numeric"}),
        }
      },
      defaultOptions: { animationData: animationData },
      notesData: [],
      idNumber: 1,
      activeModalTab: 'comments',        // 'comments' | 'ia-conversation'
      iaConversation: [],
      iaConversationLoading: false,
      password: '',
      confirmPasword: '',
      receiveNotifications:1,
      file: [],
      content: [],
      spectedColumnsindeed: [
        "nombre",
        "email",
        "teléfono",
        "estado",
        "ubicación del candidato",
        "puesto actual",
        "educación",
        "título del empleo",
        "ubicación del empleo",
        "fecha",
        "Nivel de interés",
        "Fuente",
      ],
      parsed: false,
      selectedDepartmentForAgentList: 0,
      isLoading: false,
      mobileView: true,
      activityLogs: [],
      isLoadingLogs: false,
      selectedAgents: [],
      // Enhanced upload wizard
      uploadStep: 1, // 1: Upload, 2: Map Columns, 3: Review
      uploadedFile: null,
      parsedHeaders: [],
      parsedData: [],
      columnMapping: {},
      systemFields: [
        { key: 'fullName', label: 'Full Name (will split)', required: false, isSplittable: true },
        { key: 'firstName', label: 'First Name *', required: true },
        { key: 'lastName', label: 'Last Name *', required: true },
        { key: 'email', label: 'Email', required: false },
        { key: 'phone', label: 'Phone *', required: true },
        { key: 'address', label: 'Address', required: false },
        { key: 'city', label: 'City', required: false },
        { key: 'state', label: 'State', required: false },
        { key: 'zipCode', label: 'ZIP Code', required: false },
        { key: 'birthDate', label: 'Birth Date', required: false },
        { key: 'note', label: 'Note', required: false },
      ],
      validationErrors: [],
    }
  },
  watch: {
    companies() {
      this.setPages();
    },
  },
  created() {
    this.setPages();
  },
  filters: {
    trimWords(value) {
      return value.split(" ").splice(0, 20).join(" ") + "...";
    },
  },
  methods: {
    editdata(data){

      document.getElementById('id').value= data.id
      document.getElementById('customername').value=data.name;
      document.getElementById('companyname').value=data.company;
      document.getElementById('leadsscore').value=data.score;
      document.getElementById('phone').value=data.phone;
      document.getElementById('location').value=data.location;
      document.getElementById('date').value=data.date;
    },
    async updateAgent() {

      this.errors = []

      if (!document.getElementById('editEmail').value) {
        this.errors.push('Email is required.');
      } else if (!this.validEmail(document.getElementById('editEmail').value)) {
        this.errors.push('Valid email is required.');
      }

      if (!document.getElementById('editFirstName').value) {
        this.errors.push('First Name is required.');
      }

      if (!document.getElementById('editLastName').value) {
        this.errors.push('Last Name is required.');
      }

      if (!document.getElementById('editLanguage').value) {
        this.errors.push('Language is required.');
      }

      if (!document.getElementById('editStatus').value) {
        this.errors.push('Status is required.');
      }

      if (!document.getElementById('editPhoneNumber').value) {
        this.errors.push('Phone is required.');
      }

      if(this.validPhone(document.getElementById('editPhoneNumber').value) === false && document.getElementById('editPhoneNumber').value !== ''){
        this.errors.push('Please, write a valid phone number!');
      }

      if (!document.getElementById('editDepartment').value) {
        this.errors.push('Department is required.');
      }

      if (!document.getElementById('editState').value) {
        this.errors.push('State is required.');
      }

      if (!document.getElementById('editBirthDate').value) {
        this.errors.push('Birth date is required.');
      }

      if (!document.getElementById('editAddress').value) {
        this.errors.push('Address is required.');
      }

      if (!document.getElementById('editAgentNumber').value && document.getElementById('editStatus').value === 5) {
        this.errors.push('Agent Number is required.');
      }

      if ((!document.getElementById('editLicensed').value && document.getElementById('editStatus').value === 5) || !document.getElementById('editLicensed').value) {
        this.errors.push('Insurance Licensed? is required.');
      }

      if ((!document.getElementById('editLicensed').value && document.getElementById('editStatus').value === 5) || (!this.agentData.licenseNumber && document.getElementById('editLicensed').value === 1)) {
        this.errors.push('License number is required.');
      }

      if (!this.errors.length) {
        const data = {
          username: '',
          email: document.getElementById('editEmail').value.toLowerCase(),
          firstName: document.getElementById('editFirstName').value,
          lastName: document.getElementById('editLastName').value,
          language: document.getElementById('editLanguage').value,
          status: document.getElementById('editStatus').value,
          phoneNumber: document.getElementById('editPhoneNumber').value,
          departmentID: document.getElementById('editDepartment').value,
          state: document.getElementById('editState').value,
          source: document.getElementById('editSource').value,
          city: document.getElementById('editCity').value,
          birthDate: this.formatDate(document.getElementById('editBirthDate').value, 'DD MMM, YYYY'),
          address: document.getElementById('editAddress').value,
          country: this.agentData.country || 'USA',
          postalCode: document.getElementById('editPostalCode').value,
          interviewDate: document.getElementById('editInterview').value,
          agentNumber: document.getElementById('editAgentNumber').value,
          createdBy: localStorage.getItem('email'),
          isLicensed: document.getElementById('editLicensed').value,
          licenseNumber: this.agentData.licenseNumber,
          callupUsername: document.getElementById('editCallupUsername') ? document.getElementById('editCallupUsername').value : (this.agentData.callupUsername || ''),
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id'),
          agentID: document.getElementById('id').value
        }

        this.isLoading = true;

        await axios
            .put('/api/updateAgent', data)
            .then(async response => {
              if (response) {
                document.getElementById('closemodal').click();
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Agent update successfully!'
                });
              }
            })
            .catch(async error => {
              if (error.response) {

                if(error.response.data.detail === 'Your session is expired!'){
                  await this.$router.push('logout')
                }

                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
      this.isLoading = false;
    },
    addNewAgentModal() {
      this.resetAgentData()
      document.getElementById("addform").reset();
      document.getElementById('agentModalLabel').innerHTML="Add Agent";
      document.getElementById('add-btn').style.display='block';
      document.getElementById('edit-btn').style.display='none';
      this.isEditMode = false;
      document.getElementById('editNoteOpen').style.display='none';
      document.getElementById("gMapsLink").href = '#';
      document.getElementById('editNotes').style.display='block';
    },
    async createAgent() {
      this.errors = []

      if (!this.agentData.email) {
        this.errors.push('Email is required.');
      } else if (!this.validEmail(this.agentData.email)) {
        this.errors.push('Valid email is required.');
      }

      if (!this.agentData.firstName) {
        this.errors.push('First Name is required.');
      }

      if (!this.agentData.lastName) {
        this.errors.push('Last Name is required.');
      }

      if (!this.agentData.language) {
        this.errors.push('Language is required.');
      }

      if (!this.agentData.status) {
        this.errors.push('Status is required.');
      }

      if (!this.agentData.phone) {
        this.errors.push('Phone is required.');
      }

      if (this.validPhone(this.agentData.phone) === false && this.agentData.phone !== '') {
        this.errors.push('Please, write a valid phone number!');
      }

      if (!this.agentData.department) {
        this.errors.push('Department is required.');
      }

      if (!document.getElementById('editState').value) {
        this.errors.push('State is required.');
      }

      if (!this.agentData.birthDate) {
        this.errors.push('Birth date is required.');
      }

      if (!this.agentData.address) {
        this.errors.push('Address is required.');
      }

      if (!this.agentData.agentNumber && this.agentData.status === 5) {
        this.errors.push('Agent Number is required.');
      }

      if ((!this.agentData.insuranceLicense && this.agentData.status === 5) || !this.agentData.insuranceLicense) {
        this.errors.push('is Insurance Licensed? is required.');
      }

      if ((!this.agentData.licenseNumber && this.agentData.status === 5) || (!this.agentData.licenseNumber && this.agentData.insuranceLicense === 1)) {
        this.errors.push('License number is required.');
      }

      if (!this.errors.length) {
        const data = {
          username: '',
          email: this.agentData.email.toLowerCase(),
          firstName: this.agentData.firstName,
          lastName: this.agentData.lastName,
          language: this.agentData.language,
          status: this.agentData.status,
          source: this.agentData.source,
          phoneNumber: this.agentData.phone,
          departmentID: this.agentData.department,
          state: this.agentData.state,
          city: this.agentData.city,
          birthDate: this.formatDate(this.agentData.birthDate, 'DD MMM, YYYY'),
          address: this.agentData.address,
          country: this.agentData.country,
          postalCode: this.agentData.zipCode,
          interviewDate: this.agentData.interview,
          agentNumber: this.agentData.agentNumber,
          createdBy: localStorage.getItem('email'),
          isLicensed: this.agentData.insuranceLicense,
          note: this.agentData.note,
          licenseNumber: this.agentData.licenseNumber,
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id')
        }

        await axios
            .post('/api/createAgent', data)
            .then(async response => {
              document.getElementById("addform").reset();
              if (response.data['ID'] !== null) {
                document.getElementById('closemodal').click();
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Agent created successfully!'
                });
              }
            })
            .catch(async error => {
              if (error.response) {

                if (error.response.data.detail === 'Your session is expired!') {
                  await this.$router.push('logout')
                }

                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },
    async getDepartments() {

      await axios
          .post('/api/getDepartments')
          .then(response => {
            console.log(response);
          })
          .catch(error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }

              Swal.fire("Oops!", "Something was wrong, please contact your SysAdmin.", "error")
            }
          })
    },
    copyGlobalCalendarLink(url, label) {
      navigator.clipboard.writeText(url).then(() => {
        this.copiedGlobalLabel = label;
        setTimeout(() => { this.copiedGlobalLabel = null; }, 2000);
      });
    },
    copyCalendarLink() {
      const agentId = parseInt(document.getElementById('id').value);
      const deptId = parseInt(document.getElementById('editDepartment').value);
      if (!agentId || !deptId) return;

      const a = (Number((window.BigInt(agentId) * 314159n) ^ 271828n)).toString(36);
      const d = (Number((window.BigInt(deptId) * 271828n) ^ 314159n)).toString(36);
      const url = `${window.location.origin}/schedule-interview?a=${a}&d=${d}`;

      navigator.clipboard.writeText(url).then(() => {
        this.calendarCopied = true;
        setTimeout(() => { this.calendarCopied = false; }, 2000);
      });
    },
    async getUserInfo(id) {
      document.getElementById('edit-btn').style.display = 'block';
      document.getElementById('add-btn').style.display = 'none'
      document.getElementById('agentModalLabel').innerHTML = "Edit Agent"
      this.isEditMode = true;
      this.calendarCopied = false;

      const data = {
        token: localStorage.getItem('jwt'),
        ID: id
      }

      document.getElementById('editNoteOpen').style.display = 'block';
      document.getElementById('editNotes').style.display = 'none';
      this.activeModalTab = 'comments';
      await this.getNotes(id)
      await this.getIAConversation(id)
      let agentInfo;

      await axios
          .post('/api/getUser', data)
          .then(response => {
            agentInfo = response.data
            this.setAgentData(agentInfo);
            document.getElementById('id').value = agentInfo.ID
            document.getElementById('editEmail').value = agentInfo.email;
            document.getElementById('editFirstName').value = agentInfo.firstName;
            document.getElementById('editLastName').value = agentInfo.lastName;
            document.getElementById('editLanguage').value = agentInfo.language;
            document.getElementById('editStatus').value = agentInfo.status
            document.getElementById('editPhoneNumber').value = agentInfo.phoneNumber;
            document.getElementById('editDepartment').value = agentInfo.departmentID;
            document.getElementById('editBirthDate').value = agentInfo.dateOfBirth;
            document.getElementById('editAddress').value = agentInfo.address;
            document.getElementById('editState').value = agentInfo.state;
            document.getElementById('editPostalCode').value = agentInfo.postalCode;
            document.getElementById('editAgentNumber').value = agentInfo.agentNumber;
            document.getElementById('editCreatedBy').value = agentInfo.createdBy;
            document.getElementById('editLicensed').value = agentInfo.isLicensed;
            if (document.getElementById('editCallupUsername')) {
              document.getElementById('editCallupUsername').value = agentInfo.callupUsername || '';
            }
            this.agentData.callupUsername = agentInfo.callupUsername || '';
            document.getElementById('editInterview').value = this.formatDate(agentInfo.interviewDate, 'MMMM DD, YYYY H:mm A');
            this.agentData.profileIMG = agentInfo.profileIMG;
            this.getMapsLink()
          })
          .catch(error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }

              Swal.fire("Oops!", "Something was wrong, please contact your SysAdmin.", "error")
            }
          })
    },
    validEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.trim());
    },
    validPhone: function (phone) {
      return /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(phone);
    },
    formatDate: function (date, format) {
      date = moment(date).format(format)

      if (date !== 'Invalid date') {
        return date;
      } else {
        return ' '
      }

    },
    formatDateCT: function (date) {
      if (!date) return ' ';
      const d = new Date(date);
      if (isNaN(d.getTime())) return ' ';
      return d.toLocaleString('en-US', {
        timeZone: 'America/Chicago',
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    },
    formatPhone: function (phone, flag = 0) {

      // if flag == 1 put value in phone Edit

      if (phone !== undefined) {
        if (phone.length > 10) {
          phone = phone.substring(1);
        }

        const x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      } else {
        phone = ''
      }

      if (flag !== 1) {
        return phone;
      } else {
        document.getElementById('editPhoneNumber').value = phone;
      }
    },
    setAgentData: function (data) {
      this.agentData.email = data.email;
      this.agentData.firstName = data.firstName;
      this.agentData.lastName = data.lastName;
      this.agentData.language = data.language;
      this.agentData.status = data.status
      this.agentData.source = data.source
      this.agentData.phone = data.phoneNumber;
      this.agentData.department = data.departmentID
      this.agentData.birthDate = this.formatDate(data.dateOfBirth, 'DD MMM, YYYY');
      this.agentData.interview = this.formatDate(data.interviewDate, 'MMMM DD, YYYY H:MM A');
      this.agentData.address = data.address;
      this.agentData.state = data.state;
      this.agentData.city = data.city;
      this.agentData.country = data.country;
      this.agentData.zipCode = data.postalCode;
      this.agentData.agentNumber = data.agentNumber;
      this.agentData.createdBy = data.createdBy;
      this.agentData.insuranceLicense = data.isLicensed;
      this.agentData.licenseNumber = data.licenseNumber;
      this.agentData.profileIMG = data.profileIMG;
    },
    resetAgentData: function () {
      this.agentData =
          {
            username: '',
            email: '',
            firstName: '',
            lastName: '',
            language: '',
            status: '',
            phone: '',
            department: '',
            state: '',
            birthDate: '',
            address: '',
            country: 'USA',
            zipCode: '',
            interview: '',
            agentNumber: '',
            createdBy: '',
            licenseNumber: '',
            note: '',
            profileIMG: ''
          }
    },
    parseChange(value) {
        try {
            let parsed = value;
            if (typeof value === 'string' && (value.startsWith('{') || value.startsWith('['))) {
                parsed = JSON.parse(value);
            }
            if (parsed && typeof parsed === 'object' && 'new' in parsed && 'old' in parsed) {
                return { 
                    isFormatted: true, 
                    old: parsed.old !== null && parsed.old !== undefined ? parsed.old : 'N/A', 
                    new: parsed.new !== null && parsed.new !== undefined ? parsed.new : 'N/A' 
                };
            }
            return { isFormatted: false, value: value };
        } catch (e) {
            return { isFormatted: false, value: value };
        }
    },
    formatKey(key) {
      const map = {
        'isLicensed': 'Is Licensed',
        'departmentID': 'Department',
        'lastName': 'Last Name',
        'firstName': 'First Name',
        'postalCode': 'Zip Code',
        'agentNumber': 'Agent Number',
        'dateOfBirth': 'Date Of Birth',
        'phoneNumber': 'Phone Number',
        'interviewDate': 'Interview Date',
        'licenseNumber': 'License Number',
        'username': null, // Hide this
      };
      
      if (Object.prototype.hasOwnProperty.call(map, key)) {
         return map[key];
      }
      return key.replace(/_/g, ' '); // Default fallback
    },
    formatValue(key, value) {
      // Handle Language
      if (key === 'language' || key === 'Language') {
         if (String(value) === '1') return 'Spanish';
         if (String(value) === '2') return 'English';
      }
      
      // Handle isLicensed
      if (key === 'isLicensed' || key === 'Is Licensed') {
         if (String(value) === '1' || String(value).toLowerCase() === 'yes') return 'Yes';
         if (String(value) === '0' || String(value).toLowerCase() === 'no') return 'No';
      }

       // Handle Dates
      if (key === 'interviewDate' || key === 'dateOfBirth' || key === 'Interview Date' || key === 'Date Of Birth') {
          if (value && value !== 'N/D' && value !== 'N/A' && moment(value).isValid()) {
              return moment(value).format('MMMM DD, YYYY hh:mm A');
          }
      }

      return value;
    },
    async updateAgentList(status = undefined, noReload = 0) {

      let validate = true;
      let errors = [];
      let filterLanguage = document.getElementById("filterLanguage") ? document.getElementById("filterLanguage").value : this.data.searchValues.language;
      let filterKeyword = document.getElementById("filterKeyword") ? document.getElementById("filterKeyword").value : this.data.searchValues.keyword;
      let filterLicensed = document.getElementById("filterLicensed") ? document.getElementById("filterLicensed").value : this.data.searchValues.licensed;
      let filterNotes = document.getElementById("filterNotes") ? document.getElementById("filterNotes").value : this.data.searchValues.noteSearch;
      let filterFromDate = document.getElementById("filterFromDate") ? document.getElementById("filterFromDate").value : this.data.searchValues.fromDate;
      let filterToDate = document.getElementById("filterToDate") ? document.getElementById("filterToDate").value : this.data.searchValues.toDate;
      let filterDateRange = document.getElementById("filterDateRange") ? document.getElementById("filterDateRange").value : this.data.searchValues.dateRange;
      let isActiveEl = document.querySelector('#isActive');
      let isActive = isActiveEl ? isActiveEl.checked : (this.data.searchValues.isActive === 1);

      if (status === 0 || status === '0') {
        this.data.searchValues.status = [];
        this.removeParameter('n');
      } else if (status !== undefined && status !== null) {
        if (Array.isArray(status)) {
          this.data.searchValues.status = status.map(s => String(s));
          if (this.data.searchValues.status.length > 0) {
            this.checkParameter('n', this.data.searchValues.status.join(','));
          } else {
            this.removeParameter('n');
          }
        } else {
          this.data.searchValues.status = [String(status)];
          this.checkParameter('n', String(status));
        }
      }

      if (!Array.isArray(this.data.searchValues.source)) {
        if (this.data.searchValues.source && this.data.searchValues.source !== '0') {
          this.data.searchValues.source = [String(this.data.searchValues.source)];
        } else {
          this.data.searchValues.source = [];
        }
      }

      if (!Array.isArray(this.data.searchValues.statesList)) {
        if (this.data.searchValues.statesList && this.data.searchValues.statesList !== 'ALL' && this.data.searchValues.statesList !== '0') {
          this.data.searchValues.statesList = [String(this.data.searchValues.statesList)];
        } else {
          this.data.searchValues.statesList = [];
        }
      }

      if (!Array.isArray(this.data.searchValues.department)) {
        if (this.data.searchValues.department && this.data.searchValues.department !== '0') {
          this.data.searchValues.department = [String(this.data.searchValues.department)];
        } else {
          this.data.searchValues.department = [];
        }
      }

      if (isActive === true) {
        this.data.searchValues.isActive = 1;
        if (noReload === 0) {
          this.checkParameter('active', 1);
        }
      } else {
        this.data.searchValues.isActive = 0;
        if (noReload === 0) {
          this.checkParameter('active', 0);
        }
      }

      if (filterLanguage !== '' && (filterLanguage === '1' || filterLanguage === '2')) {
        this.data.searchValues.language = filterLanguage;
        this.checkParameter('language', filterLanguage);
      } else {
        if (noReload === 0) {
          this.removeParameter('language')
        }
      }

      if (this.data.searchValues.source.length > 0) {
        if (noReload === 0) {
          this.checkParameter('source', this.data.searchValues.source.join(','));
        }
      } else {
        if (noReload === 0) {
          this.removeParameter('source')
        }
      }

      if (this.data.searchValues.statesList.length > 0) {
        if (noReload === 0) {
          this.checkParameter('state', this.data.searchValues.statesList.join(','));
        }
      } else {
        if (noReload === 0) {
          this.removeParameter('state')
        }
      }

      if (filterDateRange !== '0') {
        this.data.searchValues.dateRange = filterDateRange;
        if (noReload === 0) {
          this.checkParameter('dateRange', filterDateRange);
        }
      } else {
        if (noReload === 0) {
          this.removeParameter('dateRange')
        }
      }

      if (this.data.searchValues.department.length > 0) {
        if (noReload === 0) {
          this.checkParameter('department', this.data.searchValues.department.join(','));
        }
      } else {
        if (noReload === 0) {
          this.removeParameter('department')
        }
      }

      if (filterKeyword !== '' && filterKeyword.length >= 3) {
        this.data.searchValues.keyword = filterKeyword;
        if (noReload === 0) {
          this.checkParameter('keyword', filterKeyword);
        }
      } else if (filterKeyword !== '' && filterKeyword.length < 3) {
        errors.push('Keyword search should have 3 or more characters!');
        validate = false;
      }

      if (filterLicensed !== '') {
        this.data.searchValues.licensed = filterLicensed;
        if (noReload === 0) {
          this.checkParameter('keyword', filterLicensed);
        }
      }

      if (filterNotes !== '' && filterNotes.length >= 3) {
        this.data.searchValues.noteSearch = filterNotes;
        if (noReload === 0) {
          this.checkParameter('note', filterNotes);
        }
      } else if (filterNotes !== '' && filterNotes.length < 3) {
        errors.push('Notes search should have 3 or more characters!')
        validate = false;
      }

      var start = moment(this.formatDate(filterFromDate, 'YYYY-MM-DD'));
      var end = moment(this.formatDate(filterToDate, 'YYYY-MM-DD'));
      var days = end.diff(start, "days");

      if (days <= 366) {
        this.data.searchValues.fromDate = filterFromDate;
        this.data.searchValues.toDate = filterToDate;
        if (noReload === 0) {
          this.checkParameter('fromDate', filterFromDate);
          this.checkParameter('toDate', filterToDate);
        }
      } else {
        errors.push("From Date and To Date (range) couldn't be larger than a year (365 days)!");
        validate = false;
      }

      const data = {
        token: localStorage.getItem('jwt'),
        isProspect: 0,
        searchValues: this.data.searchValues,
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
      }

      if (validate) {
        axios
            .post('/api/listAgents', data)
            .then(response => {
              this.list = response.data
              this.listQty = this.list.length
              this.page = 1
              this.setPages()
              if (localStorage.getItem('isRec') == 1 && noReload === 0)
                this.updateRecruiterPage(window.location.href)
            })
            .catch(error => {
              if (error.response) {

                if (error.response.data.detail === 'Your session is expired!') {
                  this.$router.push('logout')
                }
                // for (const property in error.response.data) {
                // this.errors.push(`${property}: ${error.response.data[property]}`)
                // }
              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (var i = 0; i < errors.length; i += 1) {
          list += errors[i] + ' \n';
        }

        await Swal.fire("" + list, '', 'info');

      }

    },
    updateRecruiterPage(url) {
      window.location.href = url.toString();
    },
    checkParameter(key, value) {
      const url = new URL(window.location.href);
      url.searchParams.set(key, value); // set() lo actualiza si existe, o lo agrega si no

      // Opcional: cambia la URL sin recargar
      window.history.replaceState({}, "", url);
    },
    removeParameter(key) {
      const url = new URL(window.location.href);
      url.searchParams.delete(key); // Remove the parameter

      // Update the URL without reloading the page
      window.history.replaceState({}, "", url);
    },
    setPages() {

      let numberOfPages = Math.ceil(this.list.length / this.perPage);
      this.pages = []
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(companies) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return companies.slice(from, to);
    },
    filterStatus(status) {
      var statusButton = document.getElementById(status);
      statusButton.click();
    },
    deleteUser(ID) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-danger ml-2",
          cancelButton: "btn btn-success",
        },
        buttonsStyling: false,
      });
      localStorage.setItem('selectedUser', ID)
      swalWithBootstrapButtons
          .fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
            showCancelButton: true,
          })
          .then((result) => {
            if (result.value) {

              const data = {
                token: localStorage.getItem('jwt'),
                userID: localStorage.getItem('id'),
                userName: localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastname'),
                userEmail: localStorage.getItem('email'),
                agentID: localStorage.getItem('selectedUser')
              }

              axios
                  .put('/api/deleteUser', data)
                  .then(async response => {
                    if (response) {
                      await this.updateAgentList()
                      await swalWithBootstrapButtons.fire(
                          "Deleted!",
                          "Agent has been deleted.",
                          "success"
                      );
                    }
                  })
                  .catch(async error => {
                    if (error.response) {
                      let list = '';
                      for (const property in error.response.data) {
                        this.errors.push(`${property}: ${error.response.data[property]}`)
                        list += '\n' + '<b>' + error.response.data[property] + '</b>';
                      }

                      await Swal.fire({
                        title: "Please check the following: " + list,
                        icon: 'warning',
                        confirmButtonClass: "btn btn-info",
                        buttonsStyling: false,
                        showCloseButton: true,
                      });

                    } else if (error.message) {
                      this.errors.push('Something was wrong, please contact your SysAdmin.')
                    }
                  })
            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
              swalWithBootstrapButtons.fire(
                  "Cancelled",
                  "Agent is in a safe place :)",
                  "error"
              );
            }
          });
    },
    handleFocus(e) {
      e.target.setAttribute("autocomplete", "nope");
    },
    viewUserGroup(request) {
      const currentRole = jwt_decode(localStorage.getItem('jwt'))
      return currentRole.userGroup.includes(request)
    },
    async getNotes(id = localStorage.getItem('selectedUser')) {
      const data = {
        token: localStorage.getItem('jwt'),
        userID: localStorage.getItem('id'),
        agentID: id,
        clientID: id,
      }

      localStorage.setItem('selectedUser', id)

      let url = '';
      url = '/api/getUserNotes';

      await axios
          .post(url, data)
          .then(response => {
            this.notesData = response.data;
          })
          .catch(error => {
            if (error.response) {
              Swal.fire("Oops!", "Notes could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },
    async getIAConversation(id) {
      if (!id) return;
      this.iaConversationLoading = true;
      this.iaConversation = [];
      try {
        // First get the agent's phone number
        const userResp = await axios.post('/api/getUser', {
          token: localStorage.getItem('jwt'),
          ID: id
        });
        const rawPhone = (userResp.data.phoneNumber || '').replace(/\D/g, '');
        const phone = rawPhone.length > 10 ? rawPhone.slice(-10) : rawPhone;
        if (!phone || phone.length !== 10) {
          this.iaConversationLoading = false;
          return;
        }
        // Fetch conversation history from communication_messages (follow-up IA)
        const convResp = await axios.get('/api/ia/conversation', {
          params: { fromNumber: phone },
          headers: { Authorization: 'Bearer 2410)A9*3@26F8.G27H22$' }
        });
        const payload = convResp.data;
        const rawMessages = Array.isArray(payload) ? payload : (payload.messages || []);

        // Mark each message as candidate (incoming) or agency (outgoing)
        this.iaConversation = rawMessages.map(msg => {
          const fromClean = (msg.fromNumber || '').replace(/\D/g, '').slice(-10);
          return { ...msg, is_candidate: fromClean === phone };
        });
      } catch (e) {
        this.iaConversation = [];
        console.warn('[IA Conversation]', e);
      }
      this.iaConversationLoading = false;
    },


    showPassword: function () {
      var x = document.getElementById("newpasswordInput");
      var y = document.getElementById("confirmpasswordInput");
      if (x.type === "password") {
        x.type = "text";
        y.type = "text";
      } else {
        x.type = "password";
        y.type = "password";
      }
    },
    async updateUserPassword() {

      this.errors = []
      if (!this.password) {
        this.errors.push('New password is required.');
      }

      if (!this.confirmPasword) {
        this.errors.push('Confirm Password is required.');
      }

      if ((this.password !== this.confirmPasword) || (this.password.length <= 0 && this.confirmPasword.length <= 0)) {
        this.errors.push('Passwords don\'t match.');
      }

      if (!this.errors.length) {
        const data = {
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('selectedUser'),
          password: this.password,
          confirmPassword: this.confirmPasword,
        }

        await axios
            .put('/api/updateUserPassword', data)
            .then(async response => {
              if (response.status === 200) {
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Password updated!'
                });
                document.getElementById('closemodalPassword').click();
                this.password = '';
                this.confirmPasword = '';
              }
            })
            .catch(async error => {
              if (error.response) {

                if (error.response.data.detail === 'Your session is expired!') {
                  this.$router.push('logout')
                }

                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },
    setUserID(ID) {
      localStorage.setItem('selectedUser', ID)
    },
    getMapsLink() {
      let link = 'https://maps.google.com/?q='
      if (this.agentData.address.length > 0) {
        link += '+' + this.agentData.address
      }
      if (this.agentData.zipCode.length > 0) {
        link += '+' + this.agentData.zipCode
      }
      if (this.agentData.city.length > 0) {
        link += '+' + this.agentData.city
      }
      if (this.agentData.state.length > 0) {
        link += '+' + this.agentData.state
      }

      if (link !== 'https://maps.google.com/?q=') {
        document.getElementById("gMapsLink").href = link;
      } else {
        document.getElementById("gMapsLink").href = '#';
      }

    },
    async getUserPermissions() {

      const data = {
        token: localStorage.getItem('jwt'),
        userID: localStorage.getItem('selectedUser'),
        select: document.getElementById('givePermissions'),
      }

      await axios
          .post('/api/getPermissionsCount', data)
          .then(async response => {

            if (response.status === 200) {
              if (response.data === 0) {
                this.havePermissions = 2;
              } else {
                this.havePermissions = 1;
              }
            }

          })
          .catch(async error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }

              let list = '';
              for (const property in error.response.data) {
                this.errors.push(`${property}: ${error.response.data[property]}`)
                list += '\n' + '<b>' + error.response.data[property] + '</b>';
              }

              await Swal.fire({
                title: "Please check the following: " + list,
                icon: 'warning',
                confirmButtonClass: "btn btn-info",
                buttonsStyling: false,
                showCloseButton: true,
              });

            } else if (error.message) {
              this.errors.push('Something was wrong, please contact your SysAdmin.')
            }
          })
    },
    async getNotificaitons(id = 0) {

      const data = {
        token: localStorage.getItem('jwt'),
        userID: id
      }

      await axios
          .post('/api/getNotificaitons', data)
          .then(async response => {

            if (response.status === 200) {
              this.receiveNotifications = response.data;
            }

          })
          .catch(async error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }

              let list = '';
              for (const property in error.response.data) {
                this.errors.push(`${property}: ${error.response.data[property]}`)
                list += '\n' + '<b>' + error.response.data[property] + '</b>';
              }

              await Swal.fire({
                title: "Please check the following: " + list,
                icon: 'warning',
                confirmButtonClass: "btn btn-info",
                buttonsStyling: false,
                showCloseButton: true,
              });

            } else if (error.message) {
              this.errors.push('Something was wrong, please contact your SysAdmin.')
            }
          })
    },
    async permissionsToUser() {
      if (document.getElementById('givePermissions') !== '') {

        const data = {
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('selectedUser'),
          select: document.getElementById('givePermissions'),
          permission: this.havePermissions,
        }

        await axios
            .post('/api/updatePermissions', data)
            .then(async response => {

              if (response.status === 200) {

                if (this.havePermissions === '1' && response.data === 1) {
                  await Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Permissions assigned!'
                  });
                } else if (response.data === 0) {
                  await Swal.fire({
                    icon: 'info',
                    title: 'No change applied.',
                    text: 'Nothing Happens!'
                  });
                }
                {
                  await Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Permissions removed!'
                  });
                }

                document.getElementById('closemodalPassword').click();
              }

            })
            .catch(async error => {
              if (error.response) {

                if (error.response.data.detail === 'Your session is expired!') {
                  this.$router.push('logout')
                }

                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      }
    },
    handleFileUpload() {
      this.file = document.getElementById('listFile').files[0];
      this.parseFile();
    },
    async handleProfileFileUpload(event) {
      this.file = event.target.files[0];
      await this.submitProfileFile();
    },
    async submitProfileFile() {
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('userID', document.getElementById('id').value);
      formData.append('email', this.agentData.email);

      this.isLoading = true;
      axios.post('/api/comm/uploadProfilePict',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then(response => {
        this.isLoading = false;
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Profile image updated!'
          });
          // Update local data to reflect change
          // We expect the backend to update the user, so we should probably fetch the user again or just guess the URL if the backend returns it
          // Looking at uploadProfilePicture in communication/views.py, it returns {"message": "Upload Successful."} but not the URL.
          // However, we know how the URL is constructed: env('AWS_S3_BUCKET_URL') + filename
          // But since the userID is constant, and filename has a timestamp, we can't easily guess it.
          // Simplest is to just call getUserInfo again for that ID.
          this.getUserInfo(document.getElementById('id').value);
        }
      })
      .catch(error => {
        this.isLoading = false;
        console.log('FAILURE!!', error);
        Swal.fire("Oops!", "Image upload failed.", "error");
      });
    },
    parseFile() {
      var allowedExtensions = /(\.csv)$/i;
      if (allowedExtensions.exec(this.file.name)) {
        Papa.parse(this.file, {
          header: true,
          skipEmptyLines: true,
          complete: function (results) {
            if (this.compare(this.spectedColumnsindeed, results.meta.fields)) {
              this.content = results;
              this.parsed = true;
            } else {
              Swal.fire({
                title: "Oops, this file is not what we spected!",
                icon: 'warning',
                confirmButtonClass: "btn btn-info",
                buttonsStyling: false,
                showCloseButton: true,
              });
            }
          }.bind(this)
        });
      } else {
        Swal.fire({
          title: "File extension not supported!",
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },
    compare(o1, o2) {
      for (let p in o1) {
        // eslint-disable-next-line no-prototype-builtins
        if (o1.hasOwnProperty(p)) {
          if (o1[p] !== o2[p]) {
            return false;
          }
        }
      }
      for (let p in o2) {
        // eslint-disable-next-line no-prototype-builtins
        if (o2.hasOwnProperty(p)) {
          if (o1[p] !== o2[p]) {
            return false;
          }
        }
      }
      return true;
    },
    safeVal(ids = []) {
      // Busca el primer elemento existente por id y devuelve su .value o null
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el) return el.value;
      }
      return null;
    },
    async uploadFile() {

      this.errors = []
      var departmentSelected = 0;
      const isRec = localStorage.getItem('isRec') === '1';
      // Puede existir en varios lugares; evita ids duplicados
      const depVal = this.safeVal(['filterDepartment']);

      if (document.getElementById('uploadLanguage').value === '') {
        this.errors.push('Language is required.');
      }

      if (document.getElementById('uploadStatus').value === '') {
        this.errors.push('Status is required.');
      }

      if (document.getElementById('uploadType').value === '') {
        this.errors.push('Source is required.');
      }

      // Si es SUPER ADMIN y el select existe pero viene vacío => error
      if (this.viewUserGroup('SUPER_ADMIN_GROUP')) {
        // Nota: depVal será null si no existe el select
        if (depVal === '' || depVal === null || depVal === undefined) {
          this.errors.push('Department is required.');
        }
      }

      // Regla: si no existe o es '' o '0' y es recruiter, usar searchValues.department
      if ((depVal == null || depVal === '' || depVal === '0') && isRec) {
        departmentSelected = this.data.searchValues.department;
      } else if (depVal != null && depVal !== '') {
        departmentSelected = depVal;
      } else {
        // Fallback razonable si no hay select visible
        departmentSelected = this.data.searchValues.department || 0;
      }

      if (Array.isArray(departmentSelected)) {
        departmentSelected = departmentSelected.length > 0 ? departmentSelected[0] : 0;
      }

      if (this.content.length === 0) {
        this.errors.push('Please, upload and process your .csv file.');
      }

      if (this.errors.length === 0) {

        const data = {
          token: localStorage.getItem('jwt'),
          userEmail: localStorage.getItem('email'),
          userID: localStorage.getItem('id'),
          listOfData: this.content,
          uploadTo: localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastname')
              + ' | ' + localStorage.getItem('email'),
          isProspect: 0,
          language: document.getElementById('uploadLanguage').value,
          status: document.getElementById('uploadStatus').value,
          source: document.getElementById('uploadType').value,
          department: departmentSelected,
          listType: 1,
        }

        await axios
            .post('/api/uploadAgentList', data)
            .then(async response => {
              if (response.status === 200) {
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Uploaded successfully!'
                });
              }
              setTimeout(function () {
                location.reload()
              }, 2000);
            })
            .catch(async error => {
              if (error.response) {

                let list = '';
                for (const property in error.response.data) {
                  const errorMsg = Array.isArray(error.response.data[property]) 
                    ? error.response.data[property].join(', ') 
                    : error.response.data[property];
                  this.errors.push(`${property}: ${errorMsg}`)
                  list += '<br>' + '<b>' + property + ': ' + errorMsg + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following:",
                  html: list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },
    async updateNotifications() {

      this.errors = []
      let notifications = document.querySelector('#receivedNotification').checked;

      if (!this.errors.length) {
        const data = {
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('selectedUser'),
          notifications: notifications
        }

        await axios
            .put('/api/updateNotifications', data)
            .then(async response => {
              if (response.status === 200) {
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Notifications updated!'
                });
                this.password = '';
                this.confirmPasword = '';
              }
            })
            .catch(async error => {
              if (error.response) {

                if (error.response.data.detail === 'Your session is expired!') {
                  this.$router.push('logout')
                }

                await Swal.fire({
                  title: "Something went wrong... ",
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },
    // ========== ENHANCED UPLOAD WIZARD METHODS ==========
    selectedFile(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      this.uploadedFile = file;
      this.parseUploadedFile(file);
    },
    async parseUploadedFile(file) {
      const fileName = file.name.toLowerCase();
      const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
      
      try {
        if (fileExtension === '.csv') {
          await this.parseCSVFile(file);
        } else if (fileExtension === '.xlsx' || fileExtension === '.xls') {
          await this.parseExcelFile(file);
        } else {
          await Swal.fire({
            title: "Unsupported File Type",
            text: "Please upload a CSV or Excel file (.csv, .xlsx, .xls)",
            icon: 'warning',
            confirmButtonClass: "btn btn-info",
            buttonsStyling: false,
          });
        }
      } catch (error) {
        console.error('Error parsing file:', error);
        await Swal.fire({
          title: "Error Parsing File",
          text: "There was an error reading your file. Please try again.",
          icon: 'error',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
        });
      }
    },
    parseCSVFile(file) {
      return new Promise((resolve, reject) => {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            this.parsedHeaders = results.meta.fields || [];
            this.parsedData = results.data || [];
            this.autoDetectColumns();
            resolve();
          },
          error: (error) => {
            reject(error);
          }
        });
      });
    },
    parseExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            
            // Get first sheet
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            // Convert to JSON
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            
            if (jsonData.length > 0) {
              // First row is headers - ensure all are strings and filter empty
              this.parsedHeaders = jsonData[0].map(h => String(h || '').trim()).filter(h => h);
              
              // Rest is data
              this.parsedData = jsonData.slice(1).map(row => {
                const obj = {};
                this.parsedHeaders.forEach((header, index) => {
                  obj[header] = row[index] !== undefined ? String(row[index]) : '';
                });
                return obj;
              });
              
              this.autoDetectColumns();
              resolve();
            } else {
              reject(new Error('Empty file'));
            }
          } catch (error) {
            reject(error);
          }
        };
        
        reader.onerror = (error) => {
          reject(error);
        };
        
        reader.readAsArrayBuffer(file);
      });
    },
    autoDetectColumns() {
      // Auto-detect column mapping based on header names
      const mapping = {};
      
      this.parsedHeaders.forEach(header => {
        // Ensure header is a string before calling toLowerCase()
        if (!header || typeof header !== 'string') return;
        const lowerHeader = header.toLowerCase().trim();
        
        // Full Name detection (check this first before firstName/lastName)
        if (lowerHeader.includes('full') && lowerHeader.includes('name') || 
            lowerHeader === 'fullname' || 
            lowerHeader === 'nombre completo' ||
            lowerHeader === 'name') {
          mapping[header] = 'fullName';
        }
        // First Name detection
        else if (lowerHeader.includes('first') || lowerHeader.includes('nombre') || lowerHeader === 'firstname') {
          mapping[header] = 'firstName';
        }
        // Last Name detection
        else if (lowerHeader.includes('last') || lowerHeader.includes('apellido') || lowerHeader === 'lastname') {
          mapping[header] = 'lastName';
        }
        // Email detection
        else if (lowerHeader.includes('email') || lowerHeader.includes('correo') || lowerHeader.includes('e-mail')) {
          mapping[header] = 'email';
        }
        // Phone detection
        else if (lowerHeader.includes('phone') || lowerHeader.includes('tel') || lowerHeader.includes('móvil') || lowerHeader.includes('celular')) {
          mapping[header] = 'phone';
        }
        // Address detection
        else if (lowerHeader.includes('address') || lowerHeader.includes('direc') || lowerHeader.includes('ubic')) {
          mapping[header] = 'address';
        }
        // City detection
        else if (lowerHeader.includes('city') || lowerHeader.includes('ciudad')) {
          mapping[header] = 'city';
        }
        // State detection
        else if (lowerHeader.includes('state') || lowerHeader === 'estado') {
          mapping[header] = 'state';
        }
        // ZIP Code detection
        else if (lowerHeader.includes('zip') || lowerHeader.includes('postal') || lowerHeader.includes('código')) {
          mapping[header] = 'zipCode';
        }
        // Birth Date detection
        else if (lowerHeader.includes('dob') || lowerHeader.includes('birth') || lowerHeader.includes('fecha') || lowerHeader.includes('nacimiento')) {
          mapping[header] = 'birthDate';
        }
        // Note detection
        else if (lowerHeader.includes('note') || lowerHeader.includes('nota') || 
                 lowerHeader.includes('comment') || lowerHeader.includes('comentario') ||
                 lowerHeader.includes('observ') || lowerHeader.includes('info') ||
                 lowerHeader.includes('detail') || lowerHeader.includes('detalle')) {
          mapping[header] = 'note';
        }
      });
      
      this.columnMapping = mapping;
    },
    updateColumnMapping(sourceColumn, targetField) {
      if (targetField === '') {
        // Remove mapping
        delete this.columnMapping[sourceColumn];
      } else {
        this.columnMapping[sourceColumn] = targetField;
      }
    },
    getMappedFieldForColumn(column) {
      return this.columnMapping[column] || '';
    },
    nextStep() {
      if (this.uploadStep === 1) {
        // Validate file is uploaded and parsed
        if (!this.uploadedFile || this.parsedHeaders.length === 0) {
          Swal.fire({
            title: "No File Uploaded",
            text: "Please upload a file first",
            icon: 'warning',
            confirmButtonClass: "btn btn-info",
            buttonsStyling: false,
          });
          return;
        }
        this.uploadStep = 2;
      } else if (this.uploadStep === 2) {
        // Validate required fields are mapped
        const requiredFields = this.systemFields.filter(f => f.required).map(f => f.key);
        const mappedFields = Object.values(this.columnMapping);
        
        // Check if fullName is mapped (it satisfies both firstName and lastName)
        const hasFullName = mappedFields.includes('fullName');
        
        const missingFields = requiredFields.filter(field => {
          // If fullName is mapped, firstName and lastName are satisfied
          if (hasFullName && (field === 'firstName' || field === 'lastName')) {
            return false;
          }
          return !mappedFields.includes(field);
        });
        
        if (missingFields.length > 0) {
          const fieldLabels = missingFields.map(key => {
            const field = this.systemFields.find(f => f.key === key);
            return field ? field.label : key;
          }).join(', ');
          
          Swal.fire({
            title: "Missing Required Fields",
            text: `Please map the following required fields: ${fieldLabels}`,
            icon: 'warning',
            confirmButtonClass: "btn btn-info",
            buttonsStyling: false,
          });
          return;
        }
        
        this.uploadStep = 3;
      }
    },
    previousStep() {
      if (this.uploadStep > 1) {
        this.uploadStep--;
      }
    },
    resetUploadWizard() {
      this.uploadStep = 1;
      this.uploadedFile = null;
      this.parsedHeaders = [];
      this.parsedData = [];
      this.columnMapping = {};
      this.validationErrors = [];
      this.parsed = false;
      this.content = [];
      
      // Reset file input
      const fileInput = document.getElementById('listFile');
      if (fileInput) {
        fileInput.value = '';
      }
    },
    transformDataForUpload() {
      // Transform parsed data according to column mapping
      const transformedData = this.parsedData.map(row => {
        const newRow = {};
        const noteParts = []; // Collect all note parts
        
        // Map columns according to columnMapping
        Object.keys(this.columnMapping).forEach(sourceColumn => {
          const targetField = this.columnMapping[sourceColumn];
          const value = row[sourceColumn] || '';
          
          // Special handling for fullName - split into firstName and lastName
          if (targetField === 'fullName' && value) {
            const nameParts = value.trim().split(/\s+/);
            if (nameParts.length >= 2) {
              // First part is firstName, rest is lastName
              newRow['firstName'] = nameParts[0];
              newRow['lastName'] = nameParts.slice(1).join(' ');
            } else if (nameParts.length === 1) {
              // Only one name provided, use it as firstName
              newRow['firstName'] = nameParts[0];
              newRow['lastName'] = '';
            }
          }
          // Special handling for note - concatenate multiple columns
          else if (targetField === 'note' && value) {
            // Format: "Column Name: Value"
            noteParts.push(`${sourceColumn}: ${value}`);
          }
          // Regular field mapping
          else {
            // For regular fields, use the value (last one wins if multiple columns map to same field)
            newRow[targetField] = value;
          }
        });
        
        // Combine all note parts into a single note field
        if (noteParts.length > 0) {
          newRow['note'] = noteParts.join('\n');
        }
        
        return newRow;
      });
      
      // Build fields list, replacing fullName with firstName and lastName
      const fields = Object.values(this.columnMapping).map(field => {
        if (field === 'fullName') {
          return ['firstName', 'lastName'];
        }
        return field;
      }).flat();
      
      return {
        data: transformedData,
        meta: {
          fields: [...new Set(fields)] // Remove duplicates
        }
      };
    },
    async processAndUpload() {
      // Set loading state
      this.isLoading = true;
      
      try {
        // Transform data
        const transformedContent = this.transformDataForUpload();
        this.content = transformedContent;
        this.parsed = true;
        
        // Call the existing uploadFile method
        await this.uploadFile();
      } catch (error) {
        console.error('Upload error:', error);
      } finally {
        // Always reset loading state
        this.isLoading = false;
      }
    },
    getPreviewData() {
      return this.parsedData.slice(0, 5);
    },
    getMappedPreviewData() {
      // Get the transformed data (with note concatenation and fullName splitting)
      const transformed = this.transformDataForUpload();
      const preview = transformed.data.slice(0, 5);
      
      // Return the preview data with only the mapped fields
      return preview.map(row => {
        const mappedRow = {};
        // Get unique fields from the transformation
        transformed.meta.fields.forEach(field => {
          const fieldDef = this.systemFields.find(f => f.key === field);
          const fieldLabel = fieldDef?.label || field;
          mappedRow[fieldLabel] = row[field] || '';
        });
        return mappedRow;
      });
    },
    getTransformedFieldKeys() {
      // Get the field keys after transformation (fullName becomes firstName + lastName)
      const transformed = this.transformDataForUpload();
      return transformed.meta.fields;
    },
    getFieldLabel(fieldKey) {
      // Get the label for a field key
      const fieldDef = this.systemFields.find(f => f.key === fieldKey);
      return fieldDef?.label || fieldKey;
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // true for mobile device
        this.mobileView = true;
      } else {
        // false for not mobile device
        this.mobileView = false;
      }
    },
    validatesAccss: function validatesAccss() {
      const raw = localStorage.getItem('sAccss');
      if (!raw) return false;

      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) && parsed.length > 1;
      } catch (e) {
        console.error('Invalid JSON in sAccss:', e);
        return false;
      }
    },
    async getLogs(id) {
      this.isLoadingLogs = true;
      const data = {
        token: localStorage.getItem('jwt'),
        targetModel: 'User',
        targetID: id
      };
      
      try {
        const response = await axios.post('/api/management/getLogs', data);
        this.activityLogs = response.data;
      } catch (error) {
        console.error("Error fetching logs:", error);
      } finally {
        this.isLoadingLogs = false;
      }
    },
    async bulkDeleteSelected() {
        if (this.selectedAgents.length === 0) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `You are about to delete ${this.selectedAgents.length} agents. This cannot be undone!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete them!'
        });

        if (result.isConfirmed) {
            try {
                const response = await axios.post('/api/bulkDeleteUsers', {
                    token: localStorage.getItem('jwt'),
                    ids: this.selectedAgents
                });

                if (response.status === 200) {
                    Swal.fire(
                        'Deleted!',
                        `${response.data.deleted} agents have been deleted.`,
                        'success'
                    );
                    this.selectedAgents = [];
                    // Refresh list
                    this.updateAgentList();
                }
            } catch (error) {
                Swal.fire(
                    'Error!',
                    'Something went wrong deleting the agents.',
                    'error'
                );
            }
        }
    },
    async bulkUpdateStatusSelected() {
        if (this.selectedAgents.length === 0) return;

        // Prompt for status selection
        // We can use Swal with input or a custom modal. Swal with input select is easiest.
        
        // Convert statusList to object for Swal inputOptions
        const statusOptions = {};
        this.statusList.forEach(s => {
            statusOptions[s.statusID] = s.name;
        });

        const result = await Swal.fire({
            title: 'Select New Status',
            input: 'select',
            inputOptions: statusOptions,
            inputPlaceholder: 'Select a status',
            showCancelButton: true,
            confirmButtonText: 'Update',
            showLoaderOnConfirm: true,
            preConfirm: async (statusID) => {
                try {
                    const response = await axios.put('/api/bulkUpdateUserStatus', {
                        token: localStorage.getItem('jwt'),
                        ids: this.selectedAgents,
                        status: statusID
                    });
                    if (response.status !== 200) {
                      throw new Error(response.statusText)
                    }
                    return response.data
                } catch (error) {
                    Swal.showValidationMessage(
                        `Request failed: ${error}`
                    )
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        });

        if (result.isConfirmed) {
            Swal.fire(
                'Updated!',
                `${result.value.updated} agents have been updated.`,
                'success'
            );
            this.selectedAgents = [];
            this.updateAgentList();
        }
    }
  },
  async mounted() {

    this.isMobile();
    let field = 'n';
    let url = window.location.href;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const agent_id = urlParams.get('agent_id');

    if (agent_id) {
      await this.getUserInfo(agent_id);
      const btn = document.createElement('button');
      btn.style.display = 'none';
      btn.setAttribute('data-bs-toggle', 'modal');
      btn.setAttribute('data-bs-target', '#agentModal');
      document.body.appendChild(btn);
      btn.click();
      document.body.removeChild(btn);
    }

    const status = urlParams.get(field)
    const selectedState = urlParams.get('state')
    const selectedDepartment = urlParams.get('department')
    const selectedlanguage = urlParams.get('language')
    const selectedFromDate = urlParams.get('fromDate')
    const selectedToDate = urlParams.get('toDate')
    const selectedSource = urlParams.get('source')
    const selectedTimeRange = urlParams.get('dateRange')
    const selectedLicensed = urlParams.get('active')
    const selectedKeywork = urlParams.get('keywork')

    if (selectedState != null && selectedState !== 'ALL') {
      this.data.searchValues.statesList = selectedState.split(',').filter(Boolean);
    }

    if (selectedDepartment != null && selectedDepartment !== '0') {
      this.data.searchValues.department = selectedDepartment.split(',').filter(Boolean);
    }

    if (selectedlanguage != null) {
      this.data.searchValues.language = selectedlanguage;
    }

    if (selectedFromDate != null) {
      this.data.searchValues.fromDate = selectedFromDate;
    }

    if (selectedToDate != null) {
      this.data.searchValues.toDate = selectedToDate;
    }

    if (selectedSource != null && selectedSource !== '0') {
      this.data.searchValues.source = selectedSource.split(',').filter(Boolean);
    }

    if (selectedTimeRange != null) {
      this.data.searchValues.dateRange = selectedTimeRange;
    }

    if (selectedLicensed != null) {
      this.data.searchValues.licensed = selectedLicensed;
    }

    if (selectedKeywork != null) {
      this.data.searchValues.keyword = selectedKeywork;
    }

    if (urlParams.get('n') != null) {
      const nVal = urlParams.get('n');
      if (nVal && nVal !== '0') {
        this.data.searchValues.status = nVal.split(',').filter(Boolean);
      }
    }

    const data = {
      token: localStorage.getItem('jwt'),
      searchValues: this.data.searchValues,
      isActiveState: 1
    }

    await axios
        .post('/api/listDepartments', data)
        .then(response => {
          // Handle both array and single object responses
          let departments = Array.isArray(response.data) ? response.data : [response.data];
          this.departmentList = departments;
          
          // Auto-select if there's only one department
          if (departments.length === 1 && (!this.data.searchValues.department || this.data.searchValues.department.length === 0)) {
            this.data.searchValues.department = [String(departments[0].departmentID)];
          }
        })
        .catch(error => {
          if (error.response) {

            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }

            Swal.fire("Oops!", "Departments could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    await axios
        .post('/api/listStatus', data)
        .then(response => {
          this.statusList = response.data
        })
        .catch(error => {
          if (error.response) {

            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }

            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    await axios
        .post('/api/listSource', data)
        .then(response => {
          this.sourcesList = response.data
        })
        .catch(error => {
          if (error.response) {

            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }

            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    await axios
        .post('/api/listStates', data)
        .then(response => {
          this.statesList = response.data
        })
        .catch(error => {
          if (error.response) {

            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }

            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })


    if ((url.indexOf('?' + field + '=') !== -1) && status && status.length > 1 && document.getElementById(status))
      document.getElementById(status).click()
    else
      await axios
          .post('/api/listAgents', data)
          .then(response => {
            this.list = response.data;
            this.listQty = this.list.length
            this.page = 1
            this.setPages();
          })
          .catch(error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }

              // for (const property in error.response.data) {
              // this.errors.push(`${property}: ${error.response.data[property]}`)
              // }
            } else if (error.message) {
              this.errors.push('Something was wrong, please contact your SysAdmin.')
            }
          })

  },
  computed: {
    calendarLinks() {
      const token = localStorage.getItem('jwt');
      if (!token) return [];
      const decoded = jwt_decode(token);
      const agentId = decoded.ID || decoded.id;
      const encodeAgent = (id) => (Number((window.BigInt(id) * 314159n) ^ 271828n)).toString(36);
      const encodeDept = (id) => (Number((window.BigInt(id) * 271828n) ^ 314159n)).toString(36);
      const base = window.location.origin;

      let deptIds = [];
      try {
        const raw = localStorage.getItem('sAccss');
        const parsed = raw ? JSON.parse(raw) : null;
        if (Array.isArray(parsed) && parsed.length > 0) {
          deptIds = parsed.map(Number).filter(Boolean);
        }
      } catch (e) { /* ignore */ }

      if (deptIds.length === 0) {
        deptIds = [Number(decoded.departmentID)].filter(Boolean);
      }

      const depts = Array.isArray(this.departmentList) ? this.departmentList : [];
      return deptIds.map(deptId => {
        const dept = depts.find(d => Number(d.departmentID) === deptId);
        const label = dept ? dept.name : `Dept #${deptId}`;
        const url = `${base}/schedule-interview?a=${encodeAgent(agentId)}&d=${encodeDept(deptId)}`;
        return { label, url };
      });
    },
    displayedPosts() {
      return this.paginate(this.list);
    },
    selectAll: {
      get() {
        if (this.resultQuery && this.resultQuery.length > 0) {
          // If all visible items are selected
          let allSelected = true;
          for (const item of this.resultQuery) {
            if (!this.selectedAgents.includes(item.ID)) {
              allSelected = false;
              break;
            }
          }
          return allSelected;
        }
        return false;
      },
      set(value) {
        const selected = [];
        if (value) {
          this.resultQuery.forEach((agent) => {
            selected.push(agent.ID);
          });
        }
        this.selectedAgents = selected;
      }
    },
    resultQuery() {
      if (this.data.searchValues.keyword.length >= 3) {
        const search = this.data.searchValues.keyword.toLowerCase();
        return this.displayedPosts.filter((data) => {
          return (
              data.address.toLowerCase().includes(search) ||
              data.agentNumber.toLowerCase().includes(search) ||
              data.licenseNumber.toLowerCase().includes(search) ||
              data.email.toLowerCase().includes(search) ||
              data.phoneNumber.toLowerCase().includes(search) ||
              data.firstName.toLowerCase().includes(search) ||
              data.lastName.toLowerCase().includes(search) ||
              data.fullname.toLowerCase().includes(search) ||
              data.statusName.toLowerCase().includes(search)
          );
        });
      } else {
        return this.displayedPosts;
      }
    },
    sourceOptions() {
      if (!this.sourcesList) return [];
      const list = Array.isArray(this.sourcesList) ? this.sourcesList : Object.values(this.sourcesList);
      return list
        .filter(s => s && s.name && s.sourceID !== undefined)
        .map(s => ({ value: String(s.sourceID), label: s.name }));
    },
    statusOptions() {
      if (!this.statusList) return [];
      const list = Array.isArray(this.statusList) ? this.statusList : Object.values(this.statusList);
      return list
        .filter(s => s && s.name && s.statusID !== undefined)
        .map(s => ({ value: String(s.statusID), label: s.name }));
    },
    stateOptions() {
      if (!this.statesList) return [];
      const list = Array.isArray(this.statesList) ? this.statesList : Object.values(this.statesList);
      return list
        .filter(s => s && (s.value !== undefined || s.label !== undefined))
        .map(s => ({ value: String(s.value !== undefined ? s.value : s.label), label: s.label || s.value }));
    },
    departmentOptions() {
      if (!this.departmentList) return [];
      const list = Array.isArray(this.departmentList) ? this.departmentList : Object.values(this.departmentList);
      return list
        .filter(d => d && d.name && d.departmentID !== undefined)
        .map(d => ({ value: String(d.departmentID), label: d.name }));
    },
    isScheduledStatus() {
      const s = this.data.searchValues.status;
      if (Array.isArray(s)) {
        return s.includes('2') || s.includes(2);
      }
      return s === 2 || s === '2';
    },
  },
};
</script>
<style>
[data-title]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}

[data-title]:after {
  content: attr(data-title);
  position: absolute;
  bottom: -1.6em;
  left: 100%;
  padding: 4px 4px 4px 8px;
  color: #222;
  white-space: nowrap;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-box-shadow: 0px 0px 4px #222;
  -webkit-box-shadow: 0px 0px 4px #222;
  box-shadow: 0px 0px 4px #222;
  background-image: -moz-linear-gradient(top, #f8f8f8, #cccccc);
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #f8f8f8), color-stop(1, #cccccc));
  background-image: -webkit-linear-gradient(top, #f8f8f8, #cccccc);
  background-image: -moz-linear-gradient(top, #f8f8f8, #cccccc);
  background-image: -ms-linear-gradient(top, #f8f8f8, #cccccc);
  background-image: -o-linear-gradient(top, #f8f8f8, #cccccc);
  opacity: 0;
  z-index: 99999;
  visibility: hidden;
}

[data-title] {
  position: relative;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <loader v-if="isLoading" :isLoading="isLoading"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="leadsList">


          <div class="card-header">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <div class="flex-grow-1">
                <div class="row">
                  <div class="col-xxl-4 col-sm-4" style="margin-bottom: 5px;">
                    <div class="search-box">
                      <input
                          type="text"
                          class="form-control search"
                          placeholder="Search for..."
                          title="Search by (Phone number, City, Postal code, Name, Last name, Full Name, Address, State)"
                          v-model="this.data.searchValues.keyword"
                          @change="this.data.searchValues.keyword.length >= 3 ? updateAgentList(undefined,1): ''"
                          v-on:keyup.enter="this.data.searchValues.keyword === '' ? updateAgentList(undefined,1) : ''"
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>

                  <div class="col-xxl-4 col-sm-4" style="margin-bottom: 5px;">
                    <div class="d-flex align-items-center gap-2">
                      <span class="text-muted flex-shrink-0">Sort by: </span>

                      <Multiselect class="form-control"
                                   style="padding: 0px;"
                                   autocomplete="off"
                                   @focus="handleFocus"
                                   v-model="this.data.searchValues.sortBy"
                                   :close-on-select="true"
                                   :searchable="true"
                                   :options="[
                            { value: 'name', label: 'Name' },
                            { value: 'lastName', label: 'Last Name' },
                            { value: 'postalCode', label: 'Postal Code' },
                            { value: 'modified', label: 'Modified On' },
                            { value: 'created', label: 'created On' },
                            ]"
                                   @select="updateAgentList(undefined,1)"
                      />
                    </div>
                  </div>

                  <div class="col-xxl-4 col-sm-4" style="margin-bottom: 5px;">
                    <div class="d-flex align-items-center gap-2">
                      <span class="text-muted flex-shrink-0">Order by: </span>

                      <Multiselect class="form-control"
                                   style="padding: 0px;"
                                   v-model="this.data.searchValues.orderBy"
                                   autocomplete="off"
                                   @focus="handleFocus"
                                   :close-on-select="true"
                                   :searchable="true"
                                   :options="[
                            { value: 'ASC', label: 'Ascendance' },
                            { value: 'DESC', label: 'Descendant' },
                            ]"
                                   @select="updateAgentList(undefined,1)"
                      />

                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-shrink-0">
                <div class="hstack text-nowrap gap-2">
                  <div v-if="selectedAgents.length > 0" class="d-flex gap-2 me-2">
                       <button type="button" class="btn btn-danger" @click="bulkDeleteSelected">
                           <i class="ri-delete-bin-line align-bottom me-1"></i> Delete selected ({{ selectedAgents.length }})
                       </button>
                       <button type="button" class="btn btn-primary" @click="bulkUpdateStatusSelected">
                           <i class="ri-edit-line align-bottom me-1"></i> Update Status
                       </button>
                  </div>

                  <button type="button" class="btn btn-soft-success float-end" href="#open-filters"
                          data-bs-toggle="modal">
                    <i class="ri-filter-line align-bottom me-1"></i> Filters
                  </button>
                  <button type="button" class="btn btn-soft-success float-end" id="create-btn" data-bs-toggle="modal"
                          href="#agentModal" @click="addNewAgentModal" style="white-space: nowrap;">
                    <i class="ri-add-line align-bottom me-1"></i> Add Agent
                  </button>
                  <button
                      type="button"
                      id="dropdownMenuLink1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      class="btn btn-soft-info"
                  >
                    <i class="ri-more-2-fill"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                    <!--                    <li><a class="dropdown-item" href="#interiewCalendar" data-bs-toggle="modal">Open Calendar</a></li>-->
                    <li><a class="dropdown-item" href="#uploadAgents" data-bs-toggle="modal">Upload Agents</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li v-for="link in calendarLinks" :key="link.url">
                      <a class="dropdown-item" href="javascript:void(0);" @click="copyGlobalCalendarLink(link.url, link.label)">
                        <i :class="copiedGlobalLabel === link.label ? 'ri-check-line text-success' : 'ri-calendar-line text-primary'" class="me-1"></i>
                        <span v-if="calendarLinks.length > 1">
                          {{ copiedGlobalLabel === link.label ? 'Copied!' : `Interview Link (${link.label})` }}
                        </span>
                        <span v-else>
                          {{ copiedGlobalLabel === link.label ? 'Copied!' : 'Interview Link' }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Table Head -->
          <div class="tab-wrapper-scroll">
            <ul
                class="nav nav-tabs nav-tabs-custom nav-primary mb-3 flex-nowrap"
                role="tablist">

              <!-- All tab -->
              <li class="nav-item">
                <a
                    class="nav-link All py-3"
                    :class="{ active: !data.searchValues.status || data.searchValues.status.length === 0 }"
                    data-bs-toggle="tab"
                    id="All"
                    href="#home1"
                    role="tab"
                    aria-selected="true"
                    @click="updateAgentList(0,1)">
                  <i class="ri-file-search-line me-1 align-bottom"></i> All
                </a>
              </li>

              <!-- Other tabs -->
              <li class="nav-item" v-for="(data, index) of statusList" :key="index">
                <a
                    class="nav-link py-3"
                    :class="[data.name, { active: Array.isArray(this.data.searchValues.status) && this.data.searchValues.status.length === 1 && String(this.data.searchValues.status[0]) === String(data.statusID) }]"
                    data-bs-toggle="tab"
                    :id="data.name"
                    :href="'#' + data.name"
                    role="tab"
                    aria-selected="false"
                    @click="updateAgentList(data.statusID, noReload=1)">
                  <i class="me-1 align-bottom"></i>
                  {{ data.name }}
                </a>
              </li>

            </ul>
          </div>


          <div class="card-body">
            <span v-if="mobileView === false">
              <div class="table-card mb-4">
                <table class="table align-middle table-nowrap mb-0 table-hover">
              <thead class="table-light">
              <tr>
                <th scope="col" style="width: 50px">
                  <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="checkAll"
                        v-model="selectAll"
                    />
                  </div>
                </th>
                <th scope="col">Name</th>
                <th scope="col">Department</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col" v-if="isScheduledStatus">Interview Date</th>
                <th scope="col">Zip Code</th>
                <th scope="col">Create Date</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data of resultQuery" :key="data.ID">
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="data.ID" v-model="selectedAgents" :id="'check'+data.ID">
                    <label class="form-check-label" :for="'check'+data.ID"></label>
                  </div>
                </td>
                <td>{{ data.firstName }} {{ data.lastName }}</td>
                <td>{{ data.departmentName }}</td>
                <td class="truncate-email" :title="data.email">{{ data.email }}</td>
                <td>{{ formatPhone(data.phoneNumber) }}</td>
                <td v-if="isScheduledStatus">{{ formatDateCT(data.interviewDate) }}</td>
                <td>{{ data.postalCode }}</td>
                <td class="truncate-created" :title="formatDateCT(data.createdOn)"> {{ formatDateCT(data.createdOn) }} </td>
                <td><a href="javascript:void(0);" v-bind:style="'color:'+data.color"
                       @click="filterStatus(data.statusName)">{{ data.statusName }}</a></td>
                <td>
                  <ul class="list-inline hstack gap-2 mb-0">
                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                      <a class="btn btn-sm btn-soft-info edit-item-btn" href="#agentModal" data-bs-toggle="modal" @click="getUserInfo(data.ID)">
                        <i class="ri-pencil-fill align-bottom"></i>
                      </a>
                    </li>
                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Notes">
                      <a href="#open-notes" class="btn btn-sm btn-soft-warning d-inline-block" data-bs-toggle="modal" @click="getNotes(data.ID)">
                        <i class="ri-sticky-note-line fs-16"></i>
                      </a>
                    </li>
                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="History">
                      <a href="#open-history" class="btn btn-sm btn-soft-secondary d-inline-block" data-bs-toggle="modal" @click="getLogs(data.ID)">
                        <i class="ri-history-line fs-16"></i>
                      </a>
                    </li>
                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                      <a class="btn btn-sm btn-soft-danger remove-item-btn" data-bs-toggle="modal" href="javascript:void(0);" @click="deleteUser(data.ID)">
                        <i class="ri-delete-bin-fill align-bottom"></i>
                      </a>
                    </li>
                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Change Password" v-if="viewUserGroup('SUPER_ADMIN_GROUP')">
                      <a class="btn btn-sm btn-soft-success edit-item-btn" href="#open-changePassword" data-bs-toggle="modal" @click="setUserID(data.ID), getUserPermissions(), getNotificaitons(data.ID)">
                        <i class="ri-key-fill align-bottom"></i>
                      </a>
                    </li>
                  </ul>
                </td>
              </tr>
              </tbody>
            </table>
                <!--end table-->
            </div>
            </span>
            <span v-else>
            <div class="table-responsive">
              <table class=" table table-hover align-middle  mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th scope="col" class="text-center">CARDS</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data of resultQuery" :key="data.ID">
                  <td>
                    <div class="collapse show" :id="'leadDiscovered1'+data.ID">
                        <div class="card mb-1">
                            <div class="card-body" style=" padding: 10px 10px 10px 5px !important;">
                                <a class="d-flex align-items-center" data-bs-toggle="collapse"
                                   :href="'#leadDiscovered'+data.ID" role="button" aria-expanded="false"
                                   :aria-controls="'leadDiscovered'+data.ID">
                                    <div class="flex-shrink-0">
                                        <img src="@/assets/images/logo-circle-white.png" alt=""
                                             class="avatar-xs rounded-circle"/>
                                    </div>
                                    <div class="flex-grow-1 ms-3">
                                        <h6 class="fs-14 mb-1">{{ data.firstName }} {{ data.lastName }}</h6>
                                        <p class="text-muted mb-0" v-if="agentVisible">{{
                                            data.departmentName
                                          }}
                                        </p>
                                        <p class="text-muted mb-0">{{
                                            data.statusName
                                          }}
                                        </p>
                                        <p class="text-muted mb-0" v-if="isScheduledStatus">{{
                                            formatDateCT(data.interviewDate)
                                          }}
                                        </p>
                                        <p class="text-muted mb-0">{{
                                            data.email.substring(0, 30)
                                          }}
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div class="collapse border-top border-top-dashed" :id="'leadDiscovered'+data.ID">
                                <div class="card-body">
                                    <h6 class="fs-14 mb-1"><small class="badge badge-soft-primary">{{
                                        data.labelName
                                      }}</small></h6>
                                    <ul class="list-unstyled vstack gap-2 mb-0">
                                        <li>
                                            <div class="d-flex">
                                                <div class="flex-shrink-0 avatar-xxs text-muted">
                                                    <i class="ri-phone-fill"></i>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h6 class="mb-0">Phone Number</h6>
                                                    <small class="text-muted"> {{ data.phoneNumber }}</small>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="d-flex">
                                                <div class="flex-shrink-0 avatar-xxs text-muted">
                                                    <i class="ri-mail-fill"></i>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h6 class="mb-0">Email</h6>
                                                    <small class="text-muted">{{ data.email }}</small>
                                                </div>
                                            </div>
                                        </li>
                                      <li>
                                            <div class="d-flex">
                                                <div class="flex-shrink-0 avatar-xxs text-muted">
                                                    <i class="ri-calendar-2-fill"></i>
                                                </div>
                                                <div class="flex-grow-s1">
                                                    <h6 class="mb-0">Created On</h6>
                                                    <small class="text-muted">{{
                                                        formatDateCT(data.createdOn)
                                                      }}</small>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="card-footer hstack gap-2">
                                  <div class="row">
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-primary btn-sm w-100 edit-item-btn" data-bs-toggle="modal"
                                              href="#agentModal" data-bs-trigger="hover" data-bs-placement="top"
                                              title="Edit"
                                              @click="getUserInfo(data.ID)">
                                        <i class="ri-pencil-fill align-bottom me-1"></i> Edit
                                      </button>
                                    </div>
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-primary btn-sm w-100"
                                              data-bs-trigger="hover" data-bs-placement="top" title="Call">
                                          <i class="ri-phone-line align-bottom me-1"></i>
                                          <a :href="'tel:'+data.phone" style="color: white"> Make Call </a>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-warning btn-sm w-100"
                                              data-bs-toggle="modal" href="#open-notes" data-bs-trigger="hover"
                                              data-bs-placement="top" title="Notes" @click="getNotes(data.ID)">
                                          <i class="ri-refresh-fill align-bottom me-1"></i> Notes
                                      </button>
                                    </div>
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-danger btn-sm w-100"
                                              data-bs-toggle="modal" href="#open-changePassword" data-bs-trigger="hover"
                                              data-bs-placement="top" title="Change Password"
                                              @click="setUserID(data.ID), getUserPermissions(), getNotificaitons(data.ID)"
                                              v-if="viewUserGroup('SUPER_ADMIN_GROUP')">
                                           <i class="ri-key-fill align-bottom"></i>
                                            Password
                                      </button>
                                    </div>
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-info btn-sm w-100"
                                              data-bs-toggle="modal" href="#open-history" data-bs-trigger="hover"
                                              data-bs-placement="top" title="History" @click="getLogs(data.ID)">
                                          <i class="ri-history-line align-bottom me-1"></i> History
                                      </button>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div><!--end card-->
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            </span>
            <div class="noresult" v-if="list.length <= 0">
              <div class="text-center">
                <lottie
                    class="avatar-xl"
                    colors="primary:#121331,secondary:#08a88a"
                    :options="defaultOptions"
                    :height="75"
                    :width="75"
                />
                <h5 class="mt-2">Sorry!</h5>
                <p class="text-muted mb-0">
                  We've searched and we did not find any
                  agent for your search.
                </p>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-3" v-if="resultQuery.length >= 0">
              <div class="pagination-wrap hstack gap-2">
                <a
                    class="page-item pagination-prev disabled"
                    href="#"
                    v-if="page !== 1"
                    @click="page--"
                >
                  Previous
                </a>
                <ul class="pagination listjs-pagination mb-0">
                  <li
                      :class="{
                      active: pageNumber == page,
                      disabled: pageNumber == '...',
                    }"
                      v-for="(pageNumber, index) in pages.slice(
                      page - 1,
                      page + 5
                    )"
                      :key="index"
                      @click="page = pageNumber"
                  >
                    <a class="page" href="#">{{ pageNumber }}</a>
                  </li>
                </ul>
                <a
                    class="page-item pagination-next"
                    href="#"
                    @click="page++"
                    v-if="page < pages.length"
                >
                  Next
                </a>
                <span>
                  Agents Found: <b>{{ this.listQty }}</b>
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <!--  Add agent modal  -->
    <div class="modal zoomIn" id="agentModal" tabindex="-1" aria-labelledby="agentModalLabel" aria-hidden="true"
         data-bs-focus="false" style="z-index: 995;">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1000px;">
        <div class="modal-content">
          <div class="modal-header bg-light p-3">
            <h5 class="modal-title" id="agentModalLabel"></h5>
            <button
              v-if="isEditMode"
              type="button"
              class="btn btn-sm ms-2"
              :class="calendarCopied ? 'btn-success' : 'btn-outline-primary'"
              @click="copyCalendarLink"
              :title="calendarCopied ? 'Link copied!' : 'Copy interview calendar link'"
            >
              <i :class="calendarCopied ? 'ri-check-line' : 'ri-calendar-line'"></i>
              <span class="ms-1 fs-12">{{ calendarCopied ? 'Copied!' : 'Interview Link' }}</span>
            </button>
            <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"
                    id="close-modal"></button>
          </div>
          <form id="addform" @submit.prevent="" autocomplete="off">
            <div class="modal-body">
              <h6><span style="color:red; font-size: 0.7em;">Required fields (*)</span></h6>
              <input type="hidden" id="id"/>
              <div class="row g-3">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-md-3 order-md-2 text-center d-flex align-items-center justify-content-center mb-3 mb-md-0">
                      <div class="profile-user position-relative d-inline-block mx-auto mb-2">
                        <img :src="agentData.profileIMG || require('@/assets/images/logo-circle-white.png')"
                             class="rounded-circle avatar-xl img-thumbnail user-profile-image"
                             alt="user-profile-image"
                             style="width: 140px; height: 140px; object-fit: cover;">
                        <span v-if="this.agentData.email">
                          <div class="avatar-xs p-0 rounded-circle profile-photo-edit">
                            <input id="profile-img-file-input" type="file" class="profile-img-file-input"
                                   accept="image/png, image/jpeg" @change="handleProfileFileUpload($event)">
                            <label for="profile-img-file-input" class="profile-photo-edit avatar-xs">
                                <span class="avatar-title rounded-circle bg-light text-body">
                                    <i class="ri-camera-fill"></i>
                                </span>
                            </label>
                          </div>
                      </span>
                      </div>
                    </div>
                    <div class="col-md-9 order-md-1">
                      <div class="row">
                        <div class="col-lg-6">
                          <label for="editEmail" class="form-label">Email <span
                              style="color:red; font-size: 0.7em;">(*)</span></label>
                          <input type="text" id="editEmail" class="form-control mb-2" placeholder="Enter Email"
                                 v-model="agentData.email" required autocomplete="new-password">
                        </div>
                        <div class="col-lg-6">
                          <label for="editCreatedBy" class="form-label">Created By</label>
                          <input type="text" id="editCreatedBy" class="form-control mb-2" disabled
                                 v-model="this.agentData.createdBy">
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12">
                          <label for="editCallupUsername" class="form-label">CallUp Username (Integración)</label>
                          <input type="text" id="editCallupUsername" class="form-control mb-2" placeholder="CallUp Username"
                                 v-model="agentData.callupUsername">
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <label for="editFirstName" class="form-label">First Name <span
                              style="color:red; font-size: 0.7em;">(*)</span></label>
                          <input type="text" id="editFirstName" class="form-control mb-2" placeholder="Enter First Name"
                                 v-model="this.agentData.firstName" required autocomplete="new-password">
                        </div>
                        <div class="col-lg-6">
                          <label for="editLastName" class="form-label">Last Name <span style="color:red; font-size: 0.7em;">(*)</span></label>
                          <input type="text" id="editLastName" class="form-control mb-2" placeholder="Enter Last Name"
                                 v-model="this.agentData.lastName" required autocomplete="new-password">
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <label for="editLanguage" class="form-label">Language <span style="color:red; font-size: 0.7em;">(*)</span></label>
                          <select class="form-select mb-2" aria-label="Language" id="editLanguage"
                                  v-model="this.agentData.language" required>
                            <option value="1" selected>English</option>
                            <option value="2">Spanish</option>
                          </select>
                        </div>
                        <div class="col-lg-3">
                          <label for="editStatus" class="form-label">Status <span
                              style="color:red; font-size: 0.7em;">(*)</span></label>
                          <select class="form-select mb-2" aria-label="Status" id="editStatus"
                                  v-model="this.agentData.status">
                            <option
                                v-bind:style="(!viewUserGroup('SUPER_ADMIN_GROUP') && status.statusID === 9)? 'display: none;' : ''"
                                v-for="(status, statusIndex) of statusList" :key="statusIndex"
                                v-bind:value="status.statusID">{{ status.name }}
                            </option>
                          </select>
                        </div>
                        <div class="col-lg-3">
                          <label for="editSource" class="form-label">Source</label>
                          <select class="form-select mb-2" aria-label="Source" id="editSource"
                                  v-model="this.agentData.source">
                            <option v-for="(source, sourceIndex) of sourcesList" :key="sourceIndex"
                                    v-bind:value="source.sourceID">{{ source.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label for="editPhoneNumber" class="form-label">Phone <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <input type="text" id="editPhoneNumber" class="form-control mb-2" placeholder="Phone number"
                             required v-model="this.agentData.phone" autocomplete="new-password"/>
                    </div>
                    <div class="col-lg-6">
                      <label for="editDepartment" class="form-label">Department <span
                          style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Department" id="editDepartment" name="editDepartment"
                              v-model="this.agentData.department" v-if="(departmentList.length > 1)">
                        <option v-for="(department, index) of departmentList" :key="index"
                                v-bind:value="department.departmentID">{{ department.name }}
                        </option>
                      </select>
                      <select class="form-select mb-2" aria-label="Department" id="editDepartment" name="editDepartment"
                              v-model="this.agentData.department" v-else-if="departmentList.length === 1">
                        <option v-bind:value="departmentList[0].departmentID">{{ departmentList[0].name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label for="editAddress" class="form-label">Address <span
                          style="color:red; font-size: 0.7em;">(*)</span></label>&nbsp;<code><a href="#" target="_blank"
                                                                                                id="gMapsLink">Google
                      Maps</a></code>
                      <input type="text" id="editAddress" class="form-control mb-2" placeholder="Enter Address" required
                             v-model="this.agentData.address" autocomplete="new-password"/>
                    </div>
                    <div class="col-lg-6">
                      <label for="editBirthDate" class="form-label mb-2">Birth Date <span
                          style="color:red; font-size: 0.7em;">(*)</span></label>
                      <flat-pickr
                          placeholder="Select Birth Date"
                          v-model="this.agentData.birthDate"
                          :config="timeConfig"
                          class="form-control flatpickr-input"
                          id="editBirthDate"></flat-pickr>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label for="editCity" class="form-label">City</label>
                      <input type="text" id="editCity" class="form-control mb-2" placeholder="Enter City" required
                             v-model="this.agentData.city" autocomplete="new-password"/>
                    </div>
                    <div class="col-lg-6">
                      <label for="editState" class="form-label">State <span
                          style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Source" id="editState" v-model="this.agentData.state"
                              required>
                        <option v-for="(source, sourceIndex) of statesList" :key="sourceIndex"
                                v-bind:value="source.value">{{ source.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label for="editPostalCode" class="form-label">Postal code</label>
                      <input type="text" id="editPostalCode" class="form-control mb-2" placeholder="Enter Address"
                             required v-model="this.agentData.zipCode" autocomplete="new-password"/>
                    </div>
                    <div class="col-lg-6">
                      <label for="editInterview" class="form-label mb-2">Interview</label>
                      <flat-pickr
                          placeholder="Select Interview date/time"
                          v-model="this.agentData.interview"
                          :config="dateTimeConfig"
                          class="form-control flatpickr-input"
                          id="editInterview" data-enable-time></flat-pickr>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label for="editLicensed" class="form-label">Is Licensed? <span
                          style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Department" id="editLicensed"
                              v-model="this.agentData.insuranceLicense">
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label for="editAgentNumber" class="form-label">License Number</label>
                      <input type="text" id="editLicenseNumber" class="form-control mb-2"
                             placeholder="Enter Agent Number" v-model="this.agentData.licenseNumber"/>
                    </div>
                    <div class="col-lg-4">
                      <label for="editAgentNumber" class="form-label">Agent Number</label>
                      <input type="text" id="editAgentNumber" class="form-control mb-2" placeholder="Enter Agent Number"
                             v-model="this.agentData.agentNumber"/>
                    </div>
                  </div>
                  <div class="row">

                  </div>
                  <!-- ── Tab navigation ── -->
                  <div class="border-bottom mb-0" style="margin-top: 18px;">
                    <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link fw-semibold px-4"
                          :class="{ active: activeModalTab === 'comments' }"
                          @click="activeModalTab = 'comments'"
                          type="button"
                        >
                          <i class="ri-chat-3-line me-1"></i> Comments
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link fw-semibold px-4"
                          :class="{ active: activeModalTab === 'ia-conversation' }"
                          @click="activeModalTab = 'ia-conversation'"
                          type="button"
                        >
                          <i class="ri-robot-line me-1"></i> IA Conversation
                          <span v-if="iaConversation.length" class="badge bg-primary ms-1" style="font-size:0.7em;">{{ iaConversation.length }}</span>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <!-- ── Tab: Comments ── -->
                  <div v-show="activeModalTab === 'comments'">
                    <div class="row" id="editNoteOpen" style="display: block;">
                      <notes :dataList="notesData" @onFire="getNotes()" :idNumber="1"></notes>
                    </div>
                    <div class="row" id="editNotes" style="display: none;">
                      <div class="mt-3">
                        <label for="editNotes" class="form-label text-muted text-uppercase fw-semibold">Notes</label>
                        <textarea
                          class="form-control alert alert-primary"
                          v-model="this.agentData.note"
                          name="editNotes"
                          placeholder="Notes"
                          rows="2"
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <!-- ── Tab: IA Conversation ── -->
                  <div v-show="activeModalTab === 'ia-conversation'" style="margin-top: 12px;">
                    <!-- Loading -->
                    <div v-if="iaConversationLoading" class="text-center py-4">
                      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                      <span class="ms-2 text-muted">Loading conversation...</span>
                    </div>

                    <!-- Empty state -->
                    <div v-else-if="!iaConversation.length" class="text-center py-5">
                      <div class="avatar-sm mx-auto mb-3">
                        <div class="avatar-title bg-soft-info rounded-circle text-info fs-24">
                          <i class="ri-message-3-line"></i>
                        </div>
                      </div>
                      <p class="text-muted mb-0">No IA conversation found for this agent.</p>
                    </div>

                    <!-- Chat messages (read-only) -->
                    <div v-else style="max-height: 340px; overflow-y: auto; padding: 4px 2px;">
                      <div
                        v-for="(msg, idx) in iaConversation"
                        :key="idx"
                        class="d-flex mb-2"
                        :class="msg.is_candidate || msg.fromNumber === msg._candidatePhone ? 'justify-content-start' : 'justify-content-end'"
                      >
                        <!-- Incoming (candidate) -->
                        <div
                          v-if="msg.is_candidate !== false"
                          style="
                            max-width: 72%;
                            background: #f1f3f4;
                            color: #212529;
                            border-radius: 16px 16px 16px 4px;
                            padding: 8px 14px;
                            font-size: 0.85rem;
                          "
                        >
                          <div class="fw-semibold mb-1" style="font-size:0.7rem; color: #5f6368;">Agent</div>
                          <div>{{ msg.message }}</div>
                          <div class="mt-1" style="font-size:0.65rem; text-align:right; color: #7f8388;">{{ formatDate(msg.createdOn, 'YYYY-MM-DD HH:mm') }}</div>
                        </div>

                        <!-- Outgoing (agency / IA) -->
                        <div
                          v-else
                          style="
                            max-width: 72%;
                            background: linear-gradient(135deg, #405189, #0ab39c);
                            color: #fff;
                            border-radius: 16px 16px 4px 16px;
                            padding: 8px 14px;
                            font-size: 0.85rem;
                          "
                        >
                          <div class="fw-semibold mb-1" style="font-size:0.7rem; opacity:.8;">Agency (IA)</div>
                          <div>{{ msg.message }}</div>
                          <div class="mt-1" style="font-size:0.68rem; text-align:right; opacity:.75;">{{ formatDate(msg.createdOn, 'YYYY-MM-DD HH:mm') }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

              </div>
              <!--end col-->
            </div>
            <!--end row-->
          </div>
          <!--end modal-body-->

            <div class="modal-footer">
              <div class="hstack gap-2 justify-content-end">
                <button type="button" class="btn btn-light" id="closemodal" data-bs-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-success" id="add-btn" @click="createAgent">Save</button>
                <button type="button" class="btn btn-success" id="edit-btn" @click="updateAgent">Update</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Filters Modal -->
    <div id="open-filters" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true"
         style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Filters</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <label for="filterKeyword" class="form-label">Keyword</label>
                <input type="text" id="filterKeyword" name="filterKeyword" class="form-control mb-2"
                       placeholder="Enter Keyword" v-model="this.data.searchValues.keyword">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="filterLicensed" class="form-label">Licensed agents?</label>
                <select class="form-select mb-2" aria-label="Licensed Agents?" id="filterLicensed" name="filterLicensed"
                        v-model="this.data.searchValues.licensed">
                  <option value="1" selected>Both</option>
                  <option value="2">Yes</option>
                  <option value="3">No</option>
                </select>
              </div>
              <div class="col-lg-6">
                <label class="form-label">Status</label>
                <Multiselect
                  v-model="data.searchValues.status"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="false"
                  :create-option="false"
                  :options="statusOptions"
                  placeholder="All Statuses"
                  class="form-control"
                  style="padding: 0px;"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="editLanguage" class="form-label">Language</label>
                <select class="form-select mb-2" aria-label="Language" id="filterLanguage" name="filterLanguage"
                        v-model="this.data.searchValues.language">
                  <option value="3" selected>Both</option>
                  <option value="1">English</option>
                  <option value="2">Spanish</option>
                </select>
              </div>
              <div class="col-lg-6">
                <label for="editStatus" class="form-label">Search by Notes</label>
                <input type="text" id="filterNotes" name="filterNotes" class="form-control mb-2"
                       placeholder="Enter note" v-model="this.data.searchValues.noteSearch">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="filterFromDate" class="form-label"> From date </label>
                <flat-pickr
                    v-model="this.data.searchValues.fromDate"
                    :config="humanfriendlyConfig"
                    class="form-control flatpickr-input"
                    id="filterFromDate"
                    name="filterFromDate"
                ></flat-pickr>
              </div>
              <div class="col-lg-6">
                <label for="filterToDate" class="form-label"> To Date </label>
                <flat-pickr
                    v-model="this.data.searchValues.toDate"
                    :config="humanfriendlyConfig"
                    class="form-control flatpickr-input"
                    id="filterToDate"
                    name="filterToDate"
                ></flat-pickr>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label class="form-label">Source</label>
                <Multiselect
                  v-model="data.searchValues.source"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="false"
                  :create-option="false"
                  :options="sourceOptions"
                  placeholder="All Sources"
                  class="form-control"
                  style="padding: 0px;"
                  autocomplete="off"
                />
              </div>
              <div class="col-lg-6">
                <label class="form-label">State</label>
                <Multiselect
                  v-model="data.searchValues.statesList"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="false"
                  :create-option="false"
                  :options="stateOptions"
                  placeholder="All States"
                  class="form-control"
                  style="padding: 0px;"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="filterDateRange" class="form-label">Time Range</label>
                <select class="form-select mb-2" id="filterDateRange" name="filterDateRange"
                        v-model="this.data.searchValues.dateRange">
                  <option value="0" selected>...</option>
                  <option value="1">Until 2 year Ago</option>
                  <option value="2">Until 4 year Ago</option>
                  <option value="3">Until 5 year Ago</option>
                  <option value="4">Begin of times</option>
                </select>
              </div>
              <div class="col-lg-6" v-if="viewUserGroup('SUPER_ADMIN_GROUP') || validatesAccss()">
                <label class="form-label">Department</label>
                <Multiselect
                  v-model="data.searchValues.department"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="false"
                  :create-option="false"
                  :options="departmentOptions"
                  placeholder="All Departments"
                  class="form-control"
                  style="padding: 0px;"
                  autocomplete="off"
                />
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-check form-switch form-switch-lg" dir="ltr" style="margin-left: 3px;">
                  <input type="checkbox" class="form-check-input" id="isActive" checked="">
                  <label class="form-check-label" for="isActive">Active</label>
                </div>
              </div>
              <div class="col-lg-6">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="updateAgentList()">Search</button>
          </div>

        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <!-- Notes Modal -->
    <div id="open-notes" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true"
         style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <notes :dataList="notesData" @onFire="getNotes()" :idNumber="2"></notes>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <!-- History Modal -->
    <div id="open-history" class="modal fade" tabindex="-1" aria-labelledby="historyModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="historyModalLabel">Activity History</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
             <div class="d-flex justify-content-center" v-if="isLoadingLogs">
                 <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
             </div>
             <div v-else>
                 <div v-if="activityLogs.length > 0" style="max-height: 400px; overflow-y: auto;">
                      <div v-for="(log, index) in activityLogs" :key="index" class="card mb-2 border">
                          <div class="card-body p-3">
                              <div class="d-flex justify-content-between">
                                  <h6 class="mb-1 fw-bold">{{ log.action }} <span class="text-muted fw-normal">by <span :title="log.userEmail" style="cursor:help">{{ log.userName }}</span></span></h6>
                                  <small class="text-muted">{{ formatDate(log.createdOn, 'MMMM Do YYYY, h:mmA') }}</small>
                              </div>
                              <p class="mb-1 text-muted">{{ log.description }}</p>
                              
                               <div v-if="log.changes && Object.keys(log.changes).length > 0" class="mt-2 bg-light p-2 rounded">
                                  <small class="fw-bold d-block mb-1">Changes:</small>
                                  <table class="table table-sm table-borderless mb-0">
                                     <tbody>
                                        <tr v-for="(value, key) in log.changes" :key="key">
                                           <td class="fw-medium text-capitalize" style="width: 30%;" v-if="formatKey(key)">
                                              {{ formatKey(key) }}
                                           </td>
                                           <td class="text-muted" v-if="formatKey(key)">
                                               <div v-if="parseChange(value).isFormatted">
                                                   <span class="text-secondary text-decoration-line-through me-1">{{ formatValue(key, parseChange(value).old) }}</span>
                                                   <i class="mdi mdi-arrow-right text-muted mx-1"></i>
                                                   <span class="text-primary fw-medium">{{ formatValue(key, parseChange(value).new) }}</span>
                                               </div>
                                               <span v-else>{{ formatValue(key, value) }}</span>
                                           </td>
                                        </tr>
                                     </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div v-else class="text-center p-4">
                      <div class="avatar-sm mx-auto mb-3">
                          <div class="avatar-title bg-soft-warning rounded-circle text-warning fs-24">
                              <i class="ri-history-line"></i>
                          </div>
                      </div>
                      <p class="text-muted mb-0">No history available for this agent.</p>
                  </div>
             </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <!-- Change Password Modal -->
    <div class="modal zoomIn" id="open-changePassword" tabindex="-1" aria-labelledby="agentModalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1000px;">
        <div class="modal-content">
          <div class="modal-header bg-light p-3">
            <h5 class="modal-title" id="agentModalLabel"></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    id="close-modal"></button>
          </div>
          <form id="addform" @submit.prevent="">
            <div class="modal-body">
              <div class="row g-2">
                <!--end col-->
                <div class="col-lg-6">
                  <div>
                    <label for="newpasswordInput" class="form-label"
                    >New Password*</label
                    >
                    <div class="position-relative auth-pass-inputgroup mb-3">
                      <input v-model="password"
                             type="password"
                             class="form-control pe-5 password-input"
                             placeholder="Enter new password"
                             id="newpasswordInput"
                             autocomplete="off">
                      <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button" id="password-addon" @click="showPassword()"><i
                          class="ri-eye-fill align-middle"></i></button>
                    </div>
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <div>
                    <label for="confirmpasswordInput" class="form-label"
                    >Confirm Password*</label
                    >
                    <div class="position-relative auth-pass-inputgroup mb-3">
                      <input v-model="confirmPasword"
                             type="password"
                             class="form-control pe-5 password-input"
                             placeholder="Confirm password"
                             id="confirmpasswordInput"
                             autocomplete="off">
                      <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button" id="password-addon" @click="showPassword()"><i
                          class="ri-eye-fill align-middle"></i></button>
                    </div>
                  </div>
                </div>
                <!--end col-->
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <label for="givePermissions" class="form-label">Give Permissions</label>
                  <select class="form-select mb-2" aria-label="givePermissions" id="givePermissions"
                          name="givePermissions" @change="permissionsToUser()" v-model="this.havePermissions">
                    <option value="">...</option>
                    <option value="1">Yes</option>
                    <option value="2">No</option>
                  </select>
                </div>
                <div class="col-lg-6">
                  <label for="receivedNotification" class="form-label"></label>
                  <br>
                  <div class="form-check form-switch form-switch-md form-switch-success">
                    <input class="form-check-input" type="checkbox" role="switch" id="receivedNotification"
                           :checked="this.receiveNotifications" @click="updateNotifications">
                    <label class="form-check-label " for="receivedNotification">Receive Notifications?</label>
                  </div>
                </div>
              </div>

              <!--end row-->
            </div>

            <div class="modal-footer">
              <div class="hstack gap-2 justify-content-end">
                <button type="button" class="btn btn-light" id="closemodalPassword" data-bs-dismiss="modal">Close
                </button>
                <button type="button" class="btn btn-success" id="edit-btn" @click="updateUserPassword">Update</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <b-modal id="uploadAgents" title="Upload Agents" class="v-modal-custom" fullscreen @hidden="resetUploadWizard">
      <!-- Loading Overlay -->
      <div v-if="isLoading" class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" 
           style="background-color: rgba(255, 255, 255, 0.95); z-index: 9999;">
        <div class="text-center">
          <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h5 class="text-primary">Importing Agents...</h5>
          <p class="text-muted">Please wait while we process your data</p>
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-12">
          
          <!-- Step Indicator -->
          <div class="card mb-3">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center" :class="{'text-primary fw-bold': uploadStep === 1}">
                  <div class="rounded-circle d-flex align-items-center justify-content-center me-2" 
                       :class="uploadStep >= 1 ? 'bg-primary text-white' : 'bg-light'" 
                       style="width: 32px; height: 32px;">1</div>
                  <span>Upload File</span>
                </div>
                <div class="flex-grow-1 mx-3" style="height: 2px; background: #e9ecef;"></div>
                <div class="d-flex align-items-center" :class="{'text-primary fw-bold': uploadStep === 2}">
                  <div class="rounded-circle d-flex align-items-center justify-content-center me-2" 
                       :class="uploadStep >= 2 ? 'bg-primary text-white' : 'bg-light'" 
                       style="width: 32px; height: 32px;">2</div>
                  <span>Map Columns</span>
                </div>
                <div class="flex-grow-1 mx-3" style="height: 2px; background: #e9ecef;"></div>
                <div class="d-flex align-items-center" :class="{'text-primary fw-bold': uploadStep === 3}">
                  <div class="rounded-circle d-flex align-items-center justify-content-center me-2" 
                       :class="uploadStep >= 3 ? 'bg-primary text-white' : 'bg-light'" 
                       style="width: 32px; height: 32px;">3</div>
                  <span>Review & Import</span>
                </div>
              </div>
            </div>
          </div>

          <!-- STEP 1: Upload File -->
          <div v-if="uploadStep === 1" class="card">
            <div class="card-body">
              <h5 class="card-title mb-3">Step 1: Upload Your File</h5>
              <p class="text-muted">Supported formats: CSV, Excel (.xlsx, .xls)</p>
              
              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Upload Instructions</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>We accept <strong>CSV, Excel (.xlsx, .xls)</strong> files</li>
                  <li>Your file <strong>must have column headers</strong> in the first row</li>
                  <li>In the next step, you'll <strong>map each column</strong> from your file to our system fields</li>
                  <li><strong>Important:</strong> Only mapped columns will be imported - unmapped data will be skipped</li>
                  <li><em>Optional:</em> Download a template below to see the recommended format</li>
                </ul>
              </div>

              <!-- File Input -->
              <div class="mb-4">
                <input class="form-control form-control-lg" id="listFile" type="file"
                       accept=".csv,.xlsx,.xls" @change="selectedFile"/>
              </div>

              <!-- File Info -->
              <div v-if="uploadedFile" class="alert alert-success">
                <i class="ri-file-check-line me-2"></i>
                <strong>{{ uploadedFile.name }}</strong> 
                ({{ (uploadedFile.size / 1024).toFixed(2) }} KB)
                - {{ parsedData.length }} rows detected
              </div>

              <!-- Template Download -->
              <div class="mt-4">
                <h6>Need a template?</h6>
                <a href="https://dmbgroup.online/wp-content/uploads/2024/08/Plantilla-para-subir-agentes.csv" 
                   class="btn btn-sm btn-outline-success">
                  <i class="ri-download-line me-1"></i> Download CSV Template
                </a>
              </div>
            </div>
          </div>

          <!-- STEP 2: Map Columns -->
          <div v-if="uploadStep === 2" class="card">
            <div class="card-body">
              <h5 class="card-title mb-3">Step 2: Map Your Columns</h5>
              <p class="text-muted">Match your file columns to our system fields. Required fields are marked with *</p>

              <!-- Mobile Rotate Notice -->
              <div class="alert alert-danger d-block d-md-none mb-3">
                <i class="ri-smartphone-line me-1"></i> <strong>Tip:</strong> For a better experience, rotate your phone horizontally to see all columns clearly.
              </div>
              
              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Mapping Instructions</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>We've automatically detected and mapped some columns for you - <strong>please verify they are correct</strong></li>
                  <li><strong>You must select a field</strong> for each column you want to import using the dropdowns below</li>
                  <li>Fields marked with <strong>*</strong> are required (First Name or Full Name, Last Name, and Phone)</li>
                  <li>Columns set to "-- Skip this column --" will <strong>not be imported</strong></li>
                  <li>The "Sample Data" column shows the first row to help you verify the mapping</li>
                </ul>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th class="text-nowrap">Your Column</th>
                      <th class="text-nowrap">Sample Data</th>
                      <th style="min-width: 200px;">Map To Field</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(header, index) in parsedHeaders" :key="index">
                      <td class="text-nowrap"><strong>{{ header }}</strong></td>
                      <td class="text-muted text-nowrap" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis;">{{ parsedData[0] ? parsedData[0][header] : '' }}</td>
                      <td>
                        <select class="form-select" 
                                :value="getMappedFieldForColumn(header)"
                                @change="updateColumnMapping(header, $event.target.value)">
                          <option value="">-- Skip this column --</option>
                          <option v-for="field in systemFields" :key="field.key" :value="field.key">
                            {{ field.label }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- STEP 3: Review & Import -->
          <div v-if="uploadStep === 3" class="card">
            <div class="card-body">
              <h5 class="card-title mb-3">Step 3: Review & Import</h5>
              <p class="text-muted">Review the mapped data before importing</p>
              
              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Final Steps</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>Review the preview below to ensure data is mapped correctly</li>
                  <li>Fill in all required fields (Agent, Status, Language, Source)</li>
                  <li>Click "Process & Upload" to begin importing your data</li>
                  <li>Large files will be processed in chunks - please wait for completion</li>
                </ul>
              </div>

              <!-- Import Settings -->
              <div class="row mb-4">
                <div class="col-lg-3">
                  <label for="uploadLanguage" class="form-label">Language *</label>
                  <select class="form-select" id="uploadLanguage" name="uploadLanguage">
                    <option value="">...</option>
                    <option value="1">English</option>
                    <option value="2">Spanish</option>
                    <option value="3">Take from list</option>
                  </select>
                </div>
                <div class="col-lg-3">
                  <label for="uploadStatus" class="form-label">Status *</label>
                  <select class="form-select" id="uploadStatus" name="uploadStatus">
                    <option value="">...</option>
                    <option v-for="(status, statusIndex) of statusList" :key="statusIndex"
                            v-bind:value="status.statusID">{{ status.name }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-3">
                  <label for="uploadType" class="form-label">Source *</label>
                  <select class="form-select" id="uploadType" name="uploadType">
                    <option value="">...</option>
                    <option v-for="(type, typeIndex) of sourcesList" :key="typeIndex" v-bind:value="type.sourceID">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-3">
                  <span v-if="viewUserGroup('SUPER_ADMIN_GROUP')">
                    <label for="filterDepartment" class="form-label">Department *</label>
                    <select class="form-select" id="filterDepartment" name="filterDepartment"
                            v-model="this.data.searchValues.department">
                      <option value="0"> All</option>
                      <option v-for="(department, index) of departmentList" :key="index"
                              v-bind:value="department.departmentID"> {{ department.name }}
                      </option>
                    </select>
                  </span>
                  <span v-if="validatesAccss()">
                    <label for="departmentType" class="form-label">Department *</label>
                    <select class="form-select" id="departmentType" name="departmentType"
                            v-model="this.data.searchValues.department">
                      <option value="0"> All</option>
                      <option v-for="(department, index) of departmentList" :key="index"
                              v-bind:value="department.departmentID"> {{ department.name }}
                      </option>
                    </select>
                  </span>
                  <span v-if="!viewUserGroup('SUPER_ADMIN_GROUP') && !validatesAccss()">
                    <label for="departmentType" class="form-label">Department *</label>
                    <select class="form-select" id="departmentType" name="departmentType" 
                            v-model="this.data.searchValues.department">
                      <option value="0">...</option>
                      <option v-for="(department, index) of departmentList" :key="index"
                              v-bind:value="department.departmentID"> {{ department.name }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>

              <!-- Data Preview -->
              <h6>Data Preview (first 5 rows)</h6>
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr>
                      <th>#</th>
                      <th v-for="(fieldKey, index) in getTransformedFieldKeys()" 
                          :key="index">
                        {{ getFieldLabel(fieldKey) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, rowIndex) in getMappedPreviewData()" :key="rowIndex">
                      <td>{{ rowIndex + 1 }}</td>
                      <td v-for="(value, key) in row" :key="key">{{ value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="alert alert-info mt-3">
                <i class="ri-information-line me-2"></i>
                Ready to import <strong>{{ parsedData.length }}</strong> agents
              </div>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div class="d-flex justify-content-between mt-4">
            <button type="button" class="btn btn-light" @click="previousStep" 
                    v-if="uploadStep > 1">
              <i class="ri-arrow-left-line me-1"></i> Previous
            </button>
            <div></div>
            <button type="button" class="btn btn-primary" @click="nextStep" 
                    v-if="uploadStep < 3">
              Next <i class="ri-arrow-right-line ms-1"></i>
            </button>
            <button type="button" class="btn btn-success" @click="processAndUpload" 
                    v-if="uploadStep === 3">
              <i class="ri-upload-cloud-line me-1"></i> Import Agents
            </button>
          </div>

        </div>
      </div>
    </b-modal>
  </Layout>
</template>
<style>
.row-spacer {
  margin-bottom: 10px;
}

button.swal2-cancel.btn.btn-success {
  margin-left: 5px;
}

.tab-wrapper-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
}

.tab-wrapper-scroll .nav-tabs {
  flex-wrap: nowrap;
  white-space: nowrap;
}

.tab-wrapper-scroll::-webkit-scrollbar {
  display: none; /* Oculta scroll en iOS/Safari */
}

.table {
  table-layout: fixed;
  width: 100%;
  word-wrap: break-word;
}

.table th, .table td {
  white-space: normal; /* Permite que el texto baje de línea */
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 120px; /* O ajusta según tu gusto */
}

@media (max-width: 768px) {
  .table th, .table td {
    font-size: 12px;
    padding: 6px;
  }
}

td,
th {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px; /* Ajusta según tus columnas */
}

/* Specific override for Actions column if needed, or rely on max-width removal */
td:last-child,
th:last-child {
    max-width: 250px !important;
    width: 250px;
}

.truncate-email,
.truncate-created {
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>